webpackJsonp([17],{

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ele; });
var ele = function ele(id) {
  return document.getElementById(id);
};

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identifyOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identifyDesktop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isChrome; });
var identifyOS = function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
};

var identifyDesktop = function isMacintosh() {
  if (navigator.platform.indexOf('Mac') > -1) {
    return 'mac';
  } else {
    return 'win';
  }
};

var isChrome = function isChrome() {
  // only identify on mobile
  // Return cached result if avalible, else get result then cache it.
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  //alert(isChrome)
  console.log(isChrome);
  return isChrome;
};

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gen__ = __webpack_require__(4);




var state = {
  sendPasswordResetEmail_email: ''
};

var getters = {};

var mutations = {
  //
  resendEmailVerficationLink: function resendEmailVerficationLink(state2) {
    var user = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser; //if user logout before exceution of this func, it will return err
    //
    user.sendEmailVerification().then(function () {
      console.log('// Email sent.');
      //
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: 'A verfication link is sent to your registered email !'
      });
      //
    }).catch(function (error) {
      console.log('// An error happened.');
      //
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: error.message
      });
      //
    });
  },

  //
  sendPasswordResetEmail: function sendPasswordResetEmail(state2, payload) {
    //can be used for => change password (in profile)
    //
    var auth = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth();
    var emailAddress = payload.email;

    auth.sendPasswordResetEmail(emailAddress).then(function () {
      console.log('// Email sent.');
      //
      state.sendPasswordResetEmail_email = '';
      //
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: 'Password reset email sent !'
      });
      //
    }).catch(function (error) {
      console.log('// An error happened.');
      //
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: error.message
      });
      //
    });
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uploadImage_5__ = __webpack_require__(78);






var ls = __webpack_require__(27);
//
var state = {
  imaggaSuggestion: []
};

var getters = {
  imaggaSuggestion: function imaggaSuggestion(state) {
    return state.imaggaSuggestion;
  }
};

var mutations = {};

var actions = {
  //
  //
  getImaggaSuggestions: function getImaggaSuggestions(state2, payload) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
                  var url, publicId;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          //
                          // console.log("[getImaggaSuggestions]", payload)
                          //
                          url = payload.url;
                          publicId = payload.publicId;
                          //

                          state.imaggaSuggestion = [];
                          //
                          _context.next = 5;
                          return __WEBPACK_IMPORTED_MODULE_3__gen__["a" /* default */].actions.axiosGetReq(state, {
                            url: __WEBPACK_IMPORTED_MODULE_4__api__["l" /* immagaSuggestions */],
                            obj: {
                              url: url,
                              publicId: publicId
                            }
                          }).then(function (response) {
                            //
                            // console.log("[imaggaSuggestion]", response)


                            var _data = response.data;
                            // console.log({_data})
                            resolve(_data);

                            //
                            /* let imaggaSuggestions = response.data
                             //
                             state.imaggaSuggestion = gen.actions.arrayUnique(state.imaggaSuggestion.concat(imaggaSuggestions))
                             state.keywords_uploadImage = state.imaggaSuggestion // added to text-field, now searches will concat
                             //
                             ls.set('imaggaSuggestions', //saving response in local storage => landmark
                               JSON.stringify(state.imaggaSuggestion)); */
                            //
                          });

                        case 5:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__uploadImage_4__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gen__ = __webpack_require__(4);






// ALERT!!! snackbar at line 565 & remove this line *****************************
//map dependencies



// ...

var geo = __webpack_require__(53);
var GoogleMapsLoader = __webpack_require__(216);
GoogleMapsLoader.KEY = 'AIzaSyA2kK1nMxVgMkLx3M-hXodPolnlr29_vXs';
GoogleMapsLoader.LIBRARIES = ['places'];
GoogleMapsLoader.VERSION = '3.33';
var ls = __webpack_require__(27);

//



var state = {
  travelInfo: '',
  showHideMapInput: 'hide-map-input',
  mapLoader: false,
  searchBox: {},
  markers: {},
  map: {},
  getCenter: false,
  input: '',
  showMap: false,
  //
  geohash_uploadImage_3: '',
  geoLocIsAvailable_uploadImage_3: false,
  placeServices: {},
  locationAddress: '',
  geohashVal: ''
};

var getters = {
  showHideMapInput: function showHideMapInput(state) {
    return state.showHideMapInput;
  },
  mapLoader: function mapLoader(state) {
    return state.mapLoader;
  },
  showMap: function showMap(state) {
    return state.showMap;
  },
  addressDetails: function addressDetails(state) {
    return state.addressDetails;
  },
  locationAddress: function locationAddress(state) {
    return state.locationAddress;
  }
};

var mutations = {
  getInitAddress: function getInitAddress(state2, payload) {
    actions.getAddress(state, payload.lat, payload.lng).then(function (res) {
      state.locationAddress = res[1].formatted_address;
      //upload2.state. openMapDialog = false
    });
  },

  //*******************MAP SETUP*******************
  //getting map
  getMap: function getMap(state, map1) {
    GoogleMapsLoader.load(function (google) {
      // Create the search box and link it to the UI element.
      if (state.markers[0] !== undefined) {}
      mutations.setMap(state, map1);

      mutations.searchInput(state);

      // state.showHideMapInput = 'show-map-input'
      //
      setTimeout(function () {
        if (state.searchBox) {
          state.searchBox.addListener('places_changed', function () {
            var place = state.searchBox.getPlaces()[0];

            // Clear out the old markers.
            state.markers.forEach(function (marker) {
              marker.setMap(null);
            });
            state.markers = [];

            var bounds = new google.maps.LatLngBounds();

            // Create a marker for each place.
            mutations.createMarker(state, place.geometry.location);

            //
            if (place.geometry.viewport) {
              // Only geocodes have viewport.
              bounds.union(place.geometry.viewport);
            } else {
              bounds.extend(place.geometry.location);
            }
            state.map.fitBounds(bounds);
          });
        }
      }, 200
      // 2000
      );
    });
  },

  //setting up the map
  setMap: function setMap(state, map1) {
    setTimeout(function () {
      if (document.getElementById('myMap')) {
        GoogleMapsLoader.load(function (google) {
          var lat = void 0;
          var lng = void 0;
          if (state.markers.length !== 0) {
            lat = state.markers[0].getPosition().lat();
            lng = state.markers[0].getPosition().lng();
          } else {
            lat = map1.lat;
            lng = map1.lng - 0.035;
          }
          //
          state.map = {};
          state.map = new google.maps.Map(document.getElementById('myMap'), {
            center: new google.maps.LatLng(lat, lng), //map attributes
            scrollwheel: false,
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            zoom: 14, //was 18 earlier // changes for imageDetPage
            minZoom: 4, //the less is the number the less one can zoom out
            maxZoom: 21,
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_CENTER
            },
            styles: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].currentRoute.path.indexOf('imageDetails') !== -1 ? [{
              "elementType": "geometry",
              "stylers": [{
                "color": "#f5f5f5"
              }]
            }, {
              "elementType": "labels.icon",
              "stylers": [{
                "visibility": "off"
              }]
            }, {
              "elementType": "labels.text.fill",
              "stylers": [{
                "color": "#616161"
              }]
            }, {
              "elementType": "labels.text.stroke",
              "stylers": [{
                "color": "#f5f5f5"
              }]
            }, {
              "featureType": "administrative",
              "elementType": "geometry",
              "stylers": [{
                "visibility": "off"
              }]
            }, {
              "featureType": "administrative.land_parcel",
              "elementType": "labels.text.fill",
              "stylers": [{
                "color": "#bdbdbd"
              }]
            }, {
              "featureType": "poi",
              "stylers": [{
                "visibility": "off"
              }]
            }, {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [{
                "color": "#eeeeee"
              }]
            }, {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [{
                "color": "#757575"
              }]
            }, {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [{
                "color": "#e5e5e5"
              }]
            }, {
              "featureType": "poi.park",
              "elementType": "labels.text.fill",
              "stylers": [{
                "color": "#9e9e9e"
              }]
            }, {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [{
                "color": "#ffffff"
              }]
            }, {
              "featureType": "road",
              "elementType": "labels.icon",
              "stylers": [{
                "visibility": "off"
              }]
            }, {
              "featureType": "road.arterial",
              "elementType": "labels.text.fill",
              "stylers": [{
                "color": "#757575"
              }]
            }, {
              "featureType": "road.highway",
              "elementType": "geometry",
              "stylers": [{
                "color": "#dadada"
              }]
            }, {
              "featureType": "road.highway",
              "elementType": "labels.text.fill",
              "stylers": [{
                "color": "#616161"
              }]
            }, {
              "featureType": "road.local",
              "elementType": "labels.text.fill",
              "stylers": [{
                "color": "#9e9e9e"
              }]
            }, {
              "featureType": "transit",
              "stylers": [{
                "visibility": "off"
              }]
            }, {
              "featureType": "transit.line",
              "elementType": "geometry",
              "stylers": [{
                "color": "#e5e5e5"
              }]
            }, {
              "featureType": "transit.station",
              "elementType": "geometry",
              "stylers": [{
                "color": "#eeeeee"
              }]
            }, {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [{
                "color": "#c9c9c9"
              }]
            }, {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [{
                "color": "#9e9e9e"
              }]
            }] : {}
          });
          if (__WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].currentRoute.path.indexOf('/id/') !== -1) {}
        });
      }
    }, 0
    // 1000
    );
    //
  },

  // setting up the search input box
  searchInput: function searchInput(state2) {
    GoogleMapsLoader.load(function (google) {
      setTimeout(function () {
        if (state.searchBox) {
          state.input = document.getElementById('pac-input');
          var ele = document.getElementById('pac-input');
          console.log("I come here");
          state.searchBox = new google.maps.places.SearchBox(ele);
          state.map.addListener('bounds_changed', function () {
            ele.setAttribute('autocomplete', 'on');
            state.searchBox.setBounds(state.map.getBounds());
          });
        }
      }, 100);
    });
  },

  //********************* X ***************************
  skip_uploadImage_3: function skip_uploadImage_3(state, payload) {
    //
    //
    var geohash = '';
    var addressArr = [];
    var hasGeohash = false;

    //
    //decode geohash
    var lat = geo.decode(geohash).lat;
    var lon = geo.decode(geohash).lon;
    //
    mutations.getSpotTypeSuggestions(state, {
      lat: lat,
      lon: lon
    });
    //
    //route //go to imageUpload_4
    __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({
      path: '/uploadImage_4',
      query: {
        url: payload.url,
        resourceType: payload.resourceType,
        publicId: payload.publicId,
        //
        createdAt: payload.createdAt,
        //
        caption: payload.caption,
        emotionalAppeal: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(payload.emotionalAppeal),
        //
        shareSpotLocation: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({
          geohash: geohash,
          addressArr: addressArr //if empty in url, vanish on refresh
        }),
        hasGeohash: hasGeohash
      }
    });
  },

  //when component is created
  getMarkerOnCurrentLoc: function getMarkerOnCurrentLoc(state, payload) {
    GoogleMapsLoader.load(function (google) {
      state.showHideMapInput = 'hide-map-input';
      //  actions.getShopPosition(state).then(function (map) {
      if (payload.isLocAvailable === 'true' || payload.isLocAvailable === true) {
        var lat = geo.decode(payload.geohash).lat;
        var lng = geo.decode(payload.geohash).lon;

        actions.getAddress(state, lat, lng).then(function (res) {
          state.locationAddress = res[1].formatted_address;
          //upload2.state. openMapDialog = false
        });
        //
        // according to new ui, spot type has to be on 1st upload screen
        mutations.getSpotTypeSuggestions(state, {
          lat: lat,
          lon: lng
        });
        var newCoords = { lat: lat, lng: lng };
        mutations.createMarker(state, newCoords);
        mutations.getMap(state, newCoords);
      } else {
        var _newCoords = { lat: 52.5065133, lng: 13.1445565 // default location here !!!!!
        };if (__WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].currentRoute.path.indexOf('/id/') === -1) {
          if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.markers).length !== 0 && __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].currentRoute.fullPath.includes('/uploadImage_2')) {
            actions.getAddress(state, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(state.markers)[0].getPosition().lat(), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(state.markers)[0].getPosition().lng()).then(function (res) {
              document.getElementById('pac-input').innerText = res[1].formatted_address;
              setTimeout(function () {
                console.table({ table: document.getElementById('pac-input').innerText });
              }, 2000);
              //upload2.state. openMapDialog = false
            });
            mutations.getMap(state, { lat: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(state.markers)[0].getPosition().lat(), lng: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(state.markers)[0].getPosition().lng() });
            mutations.createMarker(state, { lat: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(state.markers)[0].getPosition().lat(), lng: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(state.markers)[0].getPosition().lng() });
          } else {
            mutations.getMap(state, _newCoords);
            mutations.createMarker(state, _newCoords);
          }
        } else {
          mutations.getMap(state, _newCoords);
        }
      }
      // mutations.getMarkerPosition(state, {geohash: payload.geohash, })
      //  })
    });
  },

  //creating the marker on position provided
  createMarker: function createMarker(state2, pos) {

    if (state.map) {
      GoogleMapsLoader.load(function (google) {
        state.markers = [];

        setTimeout(function () {
          state.markers.push(new google.maps.Marker({
            map: state.map,
            position: pos,
            draggable: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].currentRoute.path.indexOf('/id/') === -1 ? true : false //marker attributes
          }));
          /* actions.getAddress(state,pos.lat, pos.lng ).then((res) => {
             state.locationAddress = res.formatted_address
           }) */
        },
        // 0
        100);
      });
    }
  },
  selectMarkerLocation: function selectMarkerLocation() {
    //
    var markerLat = '';
    var markerLng = '';
    //
    state.markers.forEach(function (marker) {
      markerLat = marker.getPosition().lat();
      markerLng = marker.getPosition().lng();
      state.geohashVal = geo.encode(markerLat, markerLng);
      actions.getAddress(state, markerLat, markerLng).then(function (res) {
        state.locationAddress = res[1].formatted_address;
        state.geoLocIsAvailable_uploadImage_3 = true;

        __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__["a" /* default */].state.openMapDialog = false;
        window.thisOfVueComp.$modal.hide('mapModal');
      });
    });
  },

  // get lat lng of marker
  getMarkerPosition: function getMarkerPosition(state2, payload) {
    //
    //
    var markerLat = '';
    var markerLng = '';
    //
    state.markers.forEach(function (marker) {
      markerLat = marker.getPosition().lat();
      markerLng = marker.getPosition().lng();
    });
    //
    //getting address
    var geohash = payload.geohash;
    var addressArr = [];
    var geoLocIsAvailable = payload.geoLocIsAvailable;
    if (payload.geoLocIsAvailable != "false" && payload.geoLocIsAvailable != false) {
      actions.getAddress(state, markerLat, markerLng).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(address) {
          var addressArr;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  //
                  geohash = geo.encode(markerLat, markerLng);
                  _context.next = 3;
                  return actions.arrayOfFormattedAddress(state2, address);

                case 3:
                  addressArr = _context.sent;

                  geoLocIsAvailable = true;
                  //
                  __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({
                    path: '/uploadImage_5',
                    query: {
                      url: payload.url,
                      resourceType: payload.resourceType,
                      publicId: payload.publicId,
                      //
                      createdAt: payload.createdAt,
                      //
                      spotType: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(payload.spotType),
                      caption: payload.caption,
                      emotionalAppeal: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(payload.emotionalAppeal),
                      //
                      geohash: geohash,
                      shareSpotLocation: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({
                        geohash: geohash, //q
                        addressArr: addressArr, //if empty in url, vanish on refresh
                        addressString: address[1].formatted_address
                      }),
                      geoLocIsAvailable: geoLocIsAvailable, //q //const
                      anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot,
                      pic_desc: state.travelInfo,
                      _mon2: payload._mon2,
                      _dur2: payload._dur2
                    }
                  });
                  //
                  //decode geohash
                  /* let lat =  geo.decode(geohash).lat
                  let lon =  geo.decode(geohash).lon
                  //
                  mutations.getSpotTypeSuggestions(state, {
                    lat,
                    lon
                  })
                  path: '/uploadImage_3',
                          query: {
                            url,
                            resourceType,
                            publicId,
                            //
                            createdAt,
                            //
                            geohash,
                            geoLocIsAvailable,
                            //
                            caption,
                            emotionalAppeal: JSON.stringify(emotionalAppeal),
                            spotType:  JSON.stringify(spotType),
                            anyoneCanVisitThisSpot
                  //
                  //route //go to imageUpload_4 */

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    } else {
      __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({
        path: '/uploadImage_5',
        query: {
          url: payload.url,
          resourceType: payload.resourceType,
          publicId: payload.publicId,
          //
          createdAt: payload.createdAt,
          //
          spotType: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(payload.spotType),
          caption: payload.caption,
          emotionalAppeal: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(payload.emotionalAppeal),
          //
          geohash: geohash,
          shareSpotLocation: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({
            geohash: geohash, //q
            addressArr: addressArr, //if empty in url, vanish on refresh
            addressString: ''
          }),
          geoLocIsAvailable: geoLocIsAvailable, //q //const
          anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot,
          pic_desc: state.travelInfo
        }
      });
    }
  },
  getDrivingDirections: function getDrivingDirections(state2, payload) {
    if (state.map) {
      var calculateAndDisplayRoute = function calculateAndDisplayRoute(directionsService, directionsDisplay) {
        var icon = {
          url: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2_hdpi.png', //, // url
          scaledSize: new google.maps.Size(25, 40) // to change size of marker icon
        };

        var iconStrt = {
          url: 'https://www.google.com/maps/vt/icon/name=icons/spotlight/directions_destination_measle_8x.png&scale=2',
          scaledSize: new google.maps.Size(15, 15)
        };

        directionsService.route({
          origin: origin,
          destination: destination,
          optimizeWaypoints: true,
          travelMode: 'DRIVING'
        }, function (response, status) {
          if (status === 'OK') {
            new google.maps.DirectionsRenderer({
              map: state.map,
              directions: response,
              suppressMarkers: true
            });

            state.markers.forEach(function (mrk, index) {
              mrk.setMap(null);
            });

            var marker = new google.maps.Marker({
              position: response.routes[0].legs[0].end_location,
              map: state.map,
              icon: icon
            });

            var marker2 = new google.maps.Marker({
              position: response.routes[0].legs[0].start_location,
              map: state.map,
              icon: iconStrt
            });
            //directionsDisplay.setDirections(response);
            //state.markers[0].setMap(null)
          } else {
            // state.markers[0].setMap(null)
            // snackbar here !!!!!!!!!!!!!!!!!!!!!!!
            __WEBPACK_IMPORTED_MODULE_10__gen__["a" /* default */].mutations.snackbar_alert(state, { msg: 'Directions request failed due to ' + status });
            //  window.alert('Directions request failed due to ' + status);
          }
        });
      };

      var origin = payload.origin; // {lat: geo.decode('u336xw2h1shj').lat, lng: geo.decode('u336xw2h1shj').lon}
      var destination = payload.destination; //{lat: geo.decode('u336xqrfbe20').lat, lng: geo.decode('u336xqrfbe20').lon}
      var directionsService = new google.maps.DirectionsService();
      var directionsDisplay = new google.maps.DirectionsRenderer();
      directionsDisplay.setMap(state.map);
      calculateAndDisplayRoute(directionsService, directionsDisplay);
    }
  },

  //when locate me button is clicked
  //I haven't done it though because the way my map opend was a bit different but your's will open on your current location
  //whenever you reopen, so better store it in some letiable so that you dont have to call getShopPosition again
  getCurrentGeoLocation: function getCurrentGeoLocation() {
    if (state.map) {
      state.showHideMapInput = 'hide-map-input';
      actions.getShopPosition(state).then(function (snap) {
        var newCoords2 = { lat: snap.latitude, lng: snap.longitude };
        state.markers.forEach(function (marker) {
          marker.setMap(null);
        });
        state.markers = [];
        mutations.createMarker(state, newCoords2);
        state.map.setCenter(newCoords2);
        state.showHideMapInput = 'show-map-input';
      });
    }
  },

  //
  goTo_uploadImage_3: function goTo_uploadImage_3(state, payload) {
    mutations.getMarkerPosition(state, payload);
  },

  //
  /************************* GOOGLE PLACE API ****************************/
  getSpotTypeSuggestions: function getSpotTypeSuggestions(state2, payload) {
    //google place api
    //
    // inti
    var lat = payload.lat;
    var lon = payload.lon;
    if (state.placeServices) {
      state.placeServices = new google.maps.places.PlacesService(state.map);
      state.placeServices.nearbySearch({
        location: { lat: lat, lng: lon },
        radius: 5000,
        type: [], //types
        rankby: 'distance'
      }, callback);
    }

    //
    function callback(results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        //
        var spotTypeArr = [];
        for (var i in results) {
          if (i < 5) {
            //top 3 suggestions
            for (var j in results[i].types) {
              var spotType = results[i].types[j];
              spotTypeArr.push(spotType);
            }
          }
        }
        //
        ls.set('spotTypeSuggestions', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(spotTypeArr));
        //
      }
    }
  }
  /*********************** GOOGLE PLACE API ENDS ************************/

};

var actions = {
  //
  //your current location
  getShopPosition: function getShopPosition(_ref2) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          state.showMap = true; //return loc
          resolve(position.coords);
          // pos = position.coords
        }, function (err) {
          var markerLat = '';
          var markerLng = '';
          //
          state.markers.forEach(function (marker) {
            markerLat = marker.getPosition().lat();
            markerLng = marker.getPosition().lng();
          });
          resolve({
            latitude: markerLat,
            longitude: markerLng
          });
          //
          __WEBPACK_IMPORTED_MODULE_10__gen__["a" /* default */].mutations.snackbar_alert(state, {
            msg: err.message
          });
          //
          state.showMap = true; //only buttons hide
        });
      }
    });
  },
  arrayOfFormattedAddress: function arrayOfFormattedAddress(state2, address) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      var a = [];
      for (var i in address) {
        a.push(address[i].formatted_address);
      }
      resolve(a);
    });
  },

  //
  //get shop address
  getAddress: function getAddress(_ref3, lat, lng) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      var _this = this;

      var latlng = { lat: lat, lng: lng };
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latlng.lat + ',' + latlng.lng + '&key=AIzaSyA2kK1nMxVgMkLx3M-hXodPolnlr29_vXs&language=en').then(function (response) {
        resolve(response.data.results);
      }).catch(function (e) {
        _this.errors.push(e);
        resolve('');
      });
      // var geocoder = geocoder = new google.maps.Geocoder()
      /* geocoder.geocode({'location': latlng}, function (results, status) {
         if (status === google.maps.GeocoderStatus.OK) {
           if (results[1]) {
            // results[1].address_components => the address array that you wanted
             resolve(results[1])
           }
           else {
             resolve('')
           }
         }else {
           resolve('')
         }
       }) */
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(9);





var state = {
  userDetails_displayName: '',
  userDetails_email: '',
  userDetails_photoURL: '', //thumbnail
  //
  userDetails_profilePicUrl: ''
};

var getters = {};

var mutations = {
  //
  getUserDetails: function getUserDetails(state2) {
    //
    __WEBPACK_IMPORTED_MODULE_1__gen__["a" /* default */].state.loader = true;
    //
    //get from session
    state.userDetails_displayName = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].state.user.displayName;
    state.userDetails_email = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].state.user.email;
    state.userDetails_photoURL = __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].state.user.photoURL;
    //
    __WEBPACK_IMPORTED_MODULE_1__gen__["a" /* default */].actions.getDataFromDoc(state, {
      dbPath: 'users/' + __WEBPACK_IMPORTED_MODULE_0__auth_auth__["a" /* default */].state.user.uid
    }).then(function (userDoc) {
      //
      if (userDoc.exists) {
        //may not exits if user has not uploaded a pic.
        //
        state.userDetails_profilePicUrl = userDoc.data().picUrl;
        //
        window.thisOfVueComp.$forceUpdate();
        //
      }
      __WEBPACK_IMPORTED_MODULE_1__gen__["a" /* default */].state.loader = false;
      //
    });
  },

  //
  updateUserDetails: function updateUserDetails(state2, payload) {
    //
    var displayName = payload.displayName;
    //
    __WEBPACK_IMPORTED_MODULE_1__gen__["a" /* default */].state.btnLoader = true;
    //
    var user = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser;
    //
    user.updateProfile({
      displayName: displayName
    }).then(function () {
      //
      __WEBPACK_IMPORTED_MODULE_1__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: 'Profile Detail Updated !'
      });
      //
      state.userDetails_displayName = payload.displayName;
      //
      __WEBPACK_IMPORTED_MODULE_1__gen__["a" /* default */].state.btnLoader = false;
      //
      window.thisOfVueComp.$forceUpdate();
      window.thisOfHeader.$forceUpdate();
      //
    }).catch(function (error) {
      console.log("[profile detail update] // An error happened.", error);
    });
    //
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gen__ = __webpack_require__(4);




var state = {
  //
  authLoader: true,
  //
  isLoggedIn: false,
  user: {}
};

var getters = {
  authLoader: function authLoader(state) {
    return state.authLoader;
  },
  //
  isLoggedIn: function isLoggedIn(state) {
    return state.isLoggedIn;
  },
  user: function user(state) {
    return state.user;
  }
};

var mutations = {
  //
  logout: function logout(state2) {
    //
    __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().signOut().then(function () {
      console.log('// Sign-out successful.');
      localStorage.removeItem('homePageImages');
      localStorage.removeItem('uploader');
      //
      //window.location.reload()
      //
    }).catch(function (error) {
      console.log('// Logout // An error happened.');
    });
    //
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_auth__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_browser_extension_google_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_browser_extension_google_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_auth_browser_extension_google_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_auth_browser_extension_facebook_vue__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_auth_browser_extension_facebook_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_auth_browser_extension_facebook_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_auth_completeSignin_vue__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_auth_completeSignin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_auth_completeSignin_vue__);



//import auth from '@/store/modules/auth/auth'
//
var Hello = function Hello(resolve) {
  __webpack_require__.e/* require.ensure */(4).then((function () {
    resolve(__webpack_require__(222));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// mapView
var map = function map(resolve) {
  __webpack_require__.e/* require.ensure */(7).then((function () {
    resolve(__webpack_require__(214));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//auth
var Login = function Login(resolve) {
  __webpack_require__.e/* require.ensure */(3).then((function () {
    resolve(__webpack_require__(220));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//upload image
var uploadImage_1 = function uploadImage_1(resolve) {
  __webpack_require__.e/* require.ensure */(14).then((function () {
    resolve(__webpack_require__(227));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var uploadImage_2 = function uploadImage_2(resolve) {
  __webpack_require__.e/* require.ensure */(6).then((function () {
    resolve(__webpack_require__(228));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var uploadImage_3 = function uploadImage_3(resolve) {
  __webpack_require__.e/* require.ensure */(10).then((function () {
    resolve(__webpack_require__(229));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var uploadImage_4 = function uploadImage_4(resolve) {
  __webpack_require__.e/* require.ensure */(13).then((function () {
    resolve(__webpack_require__(230));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var uploadImage_5 = function uploadImage_5(resolve) {
  __webpack_require__.e/* require.ensure */(9).then((function () {
    resolve(__webpack_require__(231));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// image details
var imageDetails = function imageDetails(resolve) {
  __webpack_require__.e/* require.ensure */(5).then((function () {
    resolve(__webpack_require__(223));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var filter = function filter(resolve) {
  __webpack_require__.e/* require.ensure */(11).then((function () {
    resolve(__webpack_require__(221));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// upload screens

//screen 0
var uploadSreen_0 = function uploadSreen_0(resolve) {
  __webpack_require__.e/* require.ensure */(8).then((function () {
    resolve(__webpack_require__(232));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//screen 1
var uploadSreen1 = function uploadSreen1(resolve) {
  __webpack_require__.e/* require.ensure */(1).then((function () {
    resolve(__webpack_require__(108));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

//screen 2
var uploadSreen2 = function uploadSreen2(resolve) {
  __webpack_require__.e/* require.ensure */(0).then((function () {
    resolve(__webpack_require__(109));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// profile dummy page
var profile = function profile(resolve) {
  __webpack_require__.e/* require.ensure */(2).then((function () {
    resolve(__webpack_require__(225));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// page not found
var pageNotFound = function pageNotFound(resolve) {
  __webpack_require__.e/* require.ensure */(15).then((function () {
    resolve(__webpack_require__(224));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// search locations
var search_locations = function search_locations(resolve) {
  __webpack_require__.e/* require.ensure */(12).then((function () {
    resolve(__webpack_require__(226));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/', name: 'Hello', component: Hello }, // no auth - 1
  {
    path: '/map', name: 'Map', component: map
  }, // no auth - 1
  { path: '/Login', name: 'Login', component: Login }, // no auth - 2
  { path: '/complete-signin', name: 'CompleteSignin', component: __WEBPACK_IMPORTED_MODULE_6__components_auth_completeSignin_vue___default.a }, // no auth - 2
  { path: '/uploadImage_1', name: 'Upload Image 1', component: uploadImage_1 }, { path: '/uploadImage_2', name: 'Upload Image 2', component: uploadImage_2 }, { path: '/uploadImage_3', name: 'Upload Image 3', component: uploadImage_3 }, { path: '/uploadImage_4', name: 'Upload Image 4', component: uploadImage_4 }, { path: '/uploadImage_5', name: 'Upload Image 5', component: uploadImage_5 },
  // image details
  { path: '/id/:id', name: 'Image Details', component: imageDetails }, // no auth - 5
  { path: '/imageDetails/:id', name: 'old image details', redirect: { name: 'Image Details' } }, // no auth - 5
  // Filter
  { path: '/filter', name: 'Filter', component: filter },
  // new upload screens
  // screen-1
  { path: '/upload-1', name: 'Upload Screen 1', component: function component() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 108));
    } },
  // screen-2
  { path: '/upload-2', name: 'Upload Screen 2', component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 109));
    } },
  // profile page
  { path: '/profile', name: 'Profile', component: profile }, { path: '/upload-0', name: 'Upload Screen 0', component: uploadSreen_0 }, {
    path: '/auth/extension-firebase/google',
    name: 'ExtensionFirebaseGoogle',
    component: __WEBPACK_IMPORTED_MODULE_4__components_auth_browser_extension_google_vue___default.a
  }, {
    path: '/auth/extension-firebase/facebook',
    name: 'ExtensionFirebaseFacebook',
    component: __WEBPACK_IMPORTED_MODULE_5__components_auth_browser_extension_facebook_vue___default.a
  },
  //
  // { path: '/search_locations', name: 'search_locations', component: search_locations },
  // page not found
  { path: '*', name: 'pageNotFound', component: pageNotFound }]
});

var noAuthReqRoutes = ['Hello', 'Login', 'CompleteSignin', 'Image Details', 'pageNotFound', 'Profile', 'Map', 'Settings', 'Filter', 'ExtensionFirebaseGoogle', 'ExtensionFirebaseFacebook'];

router.beforeEach(function (to, from, next) {

  localStorage.setItem('to', to.name != null ? to.name : 'null');
  localStorage.setItem('from', from.name != null ? from.name : 'null');
  localStorage.setItem('toPath', to.name != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(to.query) : 'null');
  localStorage.setItem('fromPath', from.name != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(from.query) : 'null');
  localStorage.setItem('imgDet_status', 'unresolved');
  if (to.name === 'Image Details') {
    // console.log(`// check > going to image detail page...`)

    //
    if (from.name === null) {

      // console.log(`// coming from no where...`)
      localStorage.setItem('imgDet_status', 'comingFromLink');
    } else {

      // console.log(`// coming from an internal app link...`)
      //
      // hadling expection in this case.
      // console.log(`// check exception > if coming from img det itself by clicking on nearby`)
      //
      if (from.name === 'Image Details') {
        // console.log(`// coming from img det, may be clicked on nearby`)
        localStorage.setItem('imgDet_status', 'comingFromLink');
      } else {
        // console.log(`// coming from other page within app`)
        localStorage.setItem('imgDet_status', 'comingFromApp');
      }
      //
    }
  }
  // check > going to image detail page... end


  // auth not resolved.
  //setTimeout(() => {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_auth__["a" /* getLoginStatus */])().then(function (res) {
    var isLoggedIn = res.isLoggedIn;
    if (!isLoggedIn) {
      if (noAuthReqRoutes.indexOf(to.name) == -1) {
        // next(from)
        next({
          path: '/login'
        }); // restrict route
      } else {
        if (to.name !== null) {
          next();
        } else {
          next(false);
          router.push('/');
        }
      }
    } else {
      if (to.name !== null) {
        next();
      } else {
        next(false);
        router.push('/');
      }
    }
  });
  //}, 200)
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
var config = {
  apiKey: "AIzaSyAOv2-dENsFi4tjhgMnr_pWFViDZ9fIxnY",
  authDomain: "app.withaview.co",
  databaseURL: "https://prod-eu-wav.firebaseio.com",
  projectId: "prod-eu-wav",
  storageBucket: "prod-eu-wav.appspot.com",
  messagingSenderId: "615026429269",
  appId: "1:615026429269:web:abb4aaec25e891ad0ab3dc",
  measurementId: "G-M8G98775ZW"

  // apiKey: "AIzaSyCAuUeTdGQXpiV_2xru-pX4460Er0yK-Do",
  // authDomain: "dev-wav.firebaseapp.com",
  // databaseURL: "https://dev-wav.firebaseio.com",
  // projectId: "dev-wav",
  // storageBucket: "dev-wav.appspot.com",
  // messagingSenderId: "170508625596",
  // storageBucket: 'dev-wav.appspot.com'
};

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defineDbRefs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_storage__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_dbRefs__ = __webpack_require__(55);





var defineDbRefs = function defineDbRefs() {
  //
  __WEBPACK_IMPORTED_MODULE_3__store_modules_dbRefs__["a" /* default */].state.storage = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].storage(); //storage
  //
  __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].firestore().enablePersistence().then(function () {
    //console.log('// Initialize Cloud Firestore through firebase')
    __WEBPACK_IMPORTED_MODULE_3__store_modules_dbRefs__["a" /* default */].state.firestore = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].firestore(); //got firestore ref
    //console.log("firestore =>", state.firestore)
    __WEBPACK_IMPORTED_MODULE_3__store_modules_dbRefs__["a" /* default */].state.dbRefLoader = false;
  }).catch(function (err) {
    if (err.code == 'failed-precondition') {
      //console.log('// Multiple tabs open, persistence can only be enabled // in one tab at a a time.')
      __WEBPACK_IMPORTED_MODULE_3__store_modules_dbRefs__["a" /* default */].state.firestore = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].firestore(); //got firestore ref
      //console.log("firestore =>", state.firestore)
    } else if (err.code == 'unimplemented') {
      //console.log(' // The current browser does not support all of the // features required to enable persistence')
      __WEBPACK_IMPORTED_MODULE_3__store_modules_dbRefs__["a" /* default */].state.firestore = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].firestore(); //got firestore ref
      //console.log("firestore =>", state.firestore)
    }
    //
    __WEBPACK_IMPORTED_MODULE_3__store_modules_dbRefs__["a" /* default */].state.dbRefLoader = false;
  });
};

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dbRefs__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_auth_emailPassword_signup__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_auth_emailPassword_login__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_auth_emailMagic_login__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_auth_emailPassword_otherFunctions__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_auth_socialMedia__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_user_userDetails__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_user_uploadProfilePhoto__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_uploadImage_uploadImage_1__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_uploadImage_uploadImage_2__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_uploadImage_uploadImage_3__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_uploadImage_uploadImage_4__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_uploadImage_uploadImage_5__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_hello__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_uploadImage_googleCloudVisionAPI__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_uploadImage_imaggaAPI__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_common_common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_customList_customList__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_imageDetails_imageDetails__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_user_userProfile__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_filter_filter__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_filter_search_loc__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_search_search__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_search_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__modules_search_search__);


//modules


//auth






//user


//uploadImage





//

//image recognition apis


// common

// custom list

//imageDetails

//userProfileDetails

// filter

//

//

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    //
    dbRefs: __WEBPACK_IMPORTED_MODULE_2__modules_dbRefs__["a" /* default */],
    gen: __WEBPACK_IMPORTED_MODULE_3__modules_gen__["a" /* default */],
    //
    auth: __WEBPACK_IMPORTED_MODULE_4__modules_auth_auth__["a" /* default */],
    emailPassword_signup: __WEBPACK_IMPORTED_MODULE_5__modules_auth_emailPassword_signup__["a" /* default */],
    emailPassword_login: __WEBPACK_IMPORTED_MODULE_6__modules_auth_emailPassword_login__["a" /* default */],
    emailMagic_login: __WEBPACK_IMPORTED_MODULE_7__modules_auth_emailMagic_login__["a" /* default */],
    emailPassword_otherFunctions: __WEBPACK_IMPORTED_MODULE_8__modules_auth_emailPassword_otherFunctions__["a" /* default */],
    socialMedia: __WEBPACK_IMPORTED_MODULE_9__modules_auth_socialMedia__["a" /* default */],
    //
    userDetails: __WEBPACK_IMPORTED_MODULE_10__modules_user_userDetails__["a" /* default */],
    //
    uploadProfilePhoto: __WEBPACK_IMPORTED_MODULE_11__modules_user_uploadProfilePhoto__["a" /* default */],
    //
    uploadImage_1: __WEBPACK_IMPORTED_MODULE_12__modules_uploadImage_uploadImage_1__["a" /* default */],
    uploadImage_2: __WEBPACK_IMPORTED_MODULE_13__modules_uploadImage_uploadImage_2__["a" /* default */],
    uploadImage_3: __WEBPACK_IMPORTED_MODULE_14__modules_uploadImage_uploadImage_3__["a" /* default */],
    uploadImage_4: __WEBPACK_IMPORTED_MODULE_15__modules_uploadImage_uploadImage_4__["a" /* default */],
    uploadImage_5: __WEBPACK_IMPORTED_MODULE_16__modules_uploadImage_uploadImage_5__["a" /* default */],
    //
    hello: __WEBPACK_IMPORTED_MODULE_17__modules_hello__["a" /* default */],
    //
    googleCloudVisionAPI: __WEBPACK_IMPORTED_MODULE_18__modules_uploadImage_googleCloudVisionAPI__["a" /* default */],
    imaggaAPI: __WEBPACK_IMPORTED_MODULE_19__modules_uploadImage_imaggaAPI__["a" /* default */],
    //
    common: __WEBPACK_IMPORTED_MODULE_20__modules_common_common__["a" /* default */],
    //
    customList: __WEBPACK_IMPORTED_MODULE_21__modules_customList_customList__["a" /* default */],
    //
    imageDetails: __WEBPACK_IMPORTED_MODULE_22__modules_imageDetails_imageDetails__["a" /* default */],
    //
    userProfile: __WEBPACK_IMPORTED_MODULE_23__modules_user_userProfile__["a" /* default */],
    //
    filter: __WEBPACK_IMPORTED_MODULE_24__modules_filter_filter__["a" /* default */],
    search_loc: __WEBPACK_IMPORTED_MODULE_25__modules_filter_search_loc__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_26__modules_search_search___default.a
  }
});

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(524),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return immagaSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return testFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCustomList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getFilteredPhotos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return operationOnPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getParticularPhotoDetails; });
/* unused harmony export newUserAccountSetup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return userProfileDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return profileImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return uploadImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return editBasicProfileDetails; });
/* unused harmony export markExposure */
/* unused harmony export getElsewherePics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNearbyPhotos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserAllFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _top_image_section; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return upload_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createCustomToken; });
// root
var root = "https://europe-west3-prod-eu-wav.cloudfunctions.net"; //production
// const root ='http://localhost:5001/dev-wav/europe-west3'  //local db link
// const root ='https://europe-west3-dev-wav.cloudfunctions.net/' //development link
// 
// console.log('root', root)
var immagaSuggestions = root + "/imaggaSuggestions";
// test function
var testFunction = root + "/testFunction";
// custom list
var getCustomList = root + "/getPhotosInCustomList";

var getFilteredPhotos = root + "/getFilteredPhotos_3";

var operationOnPhoto = root + "/operationOnPhoto";

var getParticularPhotoDetails = root + "/getParticularPhotoDetails_2";

/*
  this api check if user is registering on the website for the first time,
  or user is already registered on the site, technically on first time register,
  it created some field in database against user's id.
*/
var newUserAccountSetup = root + "/newUserAccountSetup";
// user profile details
var userProfileDetails = function userProfileDetails(payload) {
  return root + "/getBasicProfileDetails_3?profileUid=" + payload.uid;
};
// wishlist/shared/checkins profile images
var profileImages = root + "/getOtherProfileDetails_3?isCron=" + false;

var uploadImage = root + "/uploadImage";

//export const editBasicProfileDetails = `${root}/editBasicProfileDetails?isCron=${false}`
var editBasicProfileDetails = root + "/updateProfileBasicDetails";

// mark exposure
var markExposure = root + "/markExposure?isCron=" + false;

// get elsewhere pics
var getElsewherePics = root + "/getFilteredPhotos_2";

// get nearby photos
var getNearbyPhotos = function getNearbyPhotos(payload) {
  return root + "/nearby_photos_2?geohash=" + payload.geohash + "&startAt=" + payload.startAt + "&limit=" + payload.limit + "&photoId=" + payload.photoId + "&isProperty=" + payload.isProperty + "&masterPropertyId=" + payload.masterPropertyId;
};
// get user filters
var getUserAllFilters = function getUserAllFilters(tag) {
  return root + "/user_get_all_filters?tagCat=" + tag;
};
// image det - Top section
var _top_image_section = function _top_image_section(payload) {
  return root + "/imgDet_top?photoId=" + payload.photoId + "&isLoggedIn=" + payload.isLoggedIn + "&uid=" + payload.uid;
};
// get suggestions
var getSuggestions = function getSuggestions(payload) {
  return root + "/getTagSuggestions?limit=15&tagCat=" + payload.tagCat;
};
// upload new api
var upload_2 = root + "/upload_2";

var createCustomToken = root + "/create_custom_token";

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var configurations = __webpack_require__(33);
var cloudinarySettings = configurations.cloudinary_settings;
var cloud_name = configurations.cloudinary_cloudName;
var upload_preset = configurations.cloudinary_preset;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      screenH: 0,
      screenW: 0,
      flickrImageAvailability: false
    };
  },

  methods: {
    fullscreenImage: function fullscreenImage(key, photoDetails) {
      // change these links in hello.js
      // as well, otherwise wrong url will be downloaded
      // as soon as data from api is fetched
      if (key != null) {
        if (key.match("^fse")) {
          var link = photoDetails.photoSourceLink;
          var photoLink = link.replace("original", "height" + this.screenH);
          return photoLink;
        } else {
          if (!!photoDetails.flickrImageLink) {
            var flickrLink = this.getFlickrLinkFullScreen(photoDetails.flickrImageLink);
            if (this.flickrImageLinkAvailable(flickrLink)) {
              return flickrLink;
            } else {
              return "https://res.cloudinary.com/" + cloud_name + "/image/upload/h_" + this.screenH + "," + cloudinarySettings + "/" + upload_preset + "/" + key;
            }
          } else {
            if (photoDetails.uploader === "user") {

              return "https://res.cloudinary.com/" + cloud_name + "/image/upload/h_" + this.screenH + "," + cloudinarySettings + "/" + upload_preset + "/" + key;
            } else {
              return photoDetails.photoSourceLink;
            }
          }
        }
      } else {
        return "https://res.cloudinary.com/" + cloud_name + "/image/upload/h_" + this.screenH + "," + cloudinarySettings + "/" + upload_preset + "/" + key;
      }
    },
    listviewImage: function listviewImage(key, photoDetails) {
      // for image details page top image as well
      if (key != null) {
        if (key.match("^fse")) {
          var link = photoDetails.photoSourceLink;
          var photoLink = link.replace("original", "width" + this.screenW);
          return photoLink;
        } else if (!!photoDetails.propertyLink) {
          if (photoDetails.photoSourceLink.includes("w=")) {
            var _photoLink = new URL(photoDetails.photoSourceLink);
            var baseURL = _photoLink.origin;
            var path = _photoLink.pathname;
            _photoLink.searchParams.set("w", this.screenW);
            var search = _photoLink.search;
            return baseURL + path + search;
          }
          return photoDetails.photoSourceLink;
        } else {
          if (!!photoDetails.flickrImageLink) {
            var flickrLink = this.getFlickrLink(photoDetails.flickrImageLink);
            if (this.flickrImageLinkAvailable(flickrLink)) {
              return flickrLink;
            } else {
              return photoDetails.photoSourceLink;
            }
          } else {
            return photoDetails.photoSourceLink;
          }
        }
      } else {
        return photoDetails.photoSourceLink;
      }
    },
    nearbyViewzzzImage: function nearbyViewzzzImage(key, photoDetails) {
      if (key != null) {
        if (key.match("^fse")) {
          var link = photoDetails.photoSourceLink;
          var photoLink = link.replace("original", "259x392");
          return photoLink;
        } else if (key.match("^slh") || key.match("^pg") || key.match("^vrbo") || key.match("^itc") || key.match("^ofs")) {
          if (photoDetails.photoSourceLink.includes("w=")) {
            var _photoLink2 = new URL(photoDetails.photoSourceLink);
            var baseURL = _photoLink2.origin;
            var path = _photoLink2.pathname;
            _photoLink2.searchParams.set("w", 259);
            _photoLink2.searchParams.set("h", 400);
            var search = _photoLink2.search;
            return baseURL + path + search;
          }
          return photoDetails.photoSourceLink;
        } else {
          if (!!photoDetails.flickrImageLink) {
            if (this.flickrImageLinkAvailable(photoDetails.flickrImageLink.replace("_o.", "_c."))) {
              return photoDetails.flickrImageLink.replace("_o.", "_c.");
            } else {
              return "https://res.cloudinary.com/" + cloud_name + "/image/upload/h_392,w_259,c_fill," + cloudinarySettings + "/" + upload_preset + "/" + key;
            }
          } else {
            return "https://res.cloudinary.com/" + cloud_name + "/image/upload/h_392,w_259,c_fill," + cloudinarySettings + "/" + upload_preset + "/" + key;
          }
        }
      }
    },
    profileFallBackImage: function profileFallBackImage() {
      return "https://res.cloudinary.com/" + cloud_name + "/image/upload/w_" + this.screenW + "," + cloudinarySettings + "/" + upload_preset + "/IMG_9689_fkookv_aywwr4";
    },
    mapViewImage: function mapViewImage(key, photoDetails) {
      if (key.match("^fse")) {
        var link = photoDetails.photoSourceLink;
        var photoLink = link.replace("original", "500x500");
        return photoLink;
      } else {
        if (!!photoDetails.flickrImageLink) {
          if (this.flickrImageLinkAvailable(photoDetails.flickrImageLink.replace("_o.", "_c."))) {
            return photoDetails.flickrImageLink.replace("_o.", "_c.");
          } else {
            return "https://res.cloudinary.com/" + cloud_name + "/image/upload/h_500,w_500,c_fill," + cloudinarySettings + "/" + upload_preset + "/" + key;
          }
        } else {
          if (photoDetails.photoSourceLink !== "") {
            return photoDetails.photoSourceLink;
          } else {
            return "https://res.cloudinary.com/" + cloud_name + "/image/upload/h_500,w_500,c_fill," + cloudinarySettings + "/" + upload_preset + "/" + key;
          }
        }
      }
    },
    profileLinksImage: function profileLinksImage(key) {
      return "https://res.cloudinary.com/" + cloud_name + "/image/upload/w_600,h_900,c_fill," + cloudinarySettings + "/" + upload_preset + "/" + key;
    },
    passcodeImage: function passcodeImage() {
      return "https://res.cloudinary.com/" + cloud_name + "/image/upload/w_600,h_900,c_fill," + cloudinarySettings + ",e_blur:400/" + upload_preset + "/awmu8hhyxzzr9cunn3j5";
    },
    blurImage: function blurImage(key, photoSourceLink) {
      if (key.match("^fse")) {
        var link = photoSourceLink;
        var photoLink = link.replace("original", "900x600");
        return photoLink;
      } else {
        return "https://res.cloudinary.com/" + cloud_name + "/image/upload/w_600,h_900,c_fill," + cloudinarySettings + "/" + upload_preset + "/" + key;
      }
    },
    filterImage: function filterImage(key) {
      return "https://res.cloudinary.com/" + cloud_name + "/image/upload/h_200,c_fill," + cloudinarySettings + "/" + upload_preset + "/" + key;
    },
    getFlickrLink: function getFlickrLink(photoLink) {
      if (this.screenW > 1200 && this.screenW < 1600) {
        return photoLink.replace("_o.", "_h.");
      } else if (this.screenW > 1600) {
        return photoLink.replace("_o.", "_k.");
      } else if (this.screenW < 1200 && this.screenW > 800) {
        return photoLink.replace("_o.", "_b.");
      } else if (this.screenW <= 800) {
        return photoLink.replace("_o.", "_c.");
      }
    },
    getFlickrLinkFullScreen: function getFlickrLinkFullScreen(photoLink) {
      if (this.screenH > 1200 && this.screenH < 1600) {
        return photoLink.replace("_o.", "_h.");
      } else if (this.screenH > 1600) {
        return photoLink.replace("_o.", "_k.");
      } else if (this.screenH < 1200) {
        return photoLink.replace("_o.", "_k.");
      }
    },
    flickrImageLinkAvailable: function flickrImageLinkAvailable(photoLink) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.flickrImageAvailability = false;
                _context.next = 3;
                return fetch(photoLink).then(function (response) {
                  if (response.status < 400) {
                    _this.flickrImageAvailability = true;
                  } else if (response.status === 403) {
                    _this.flickrImageAvailability = false;
                  } else if (response.status === 404) {
                    _this.flickrImageAvailability = false;
                  };
                });

              case 3:
                return _context.abrupt("return", _this.flickrImageAvailability);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  created: function created() {
    this.screenH = screen.height;
    this.screenW = screen.width;
  }
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_identifyOS__ = __webpack_require__(107);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // native share
    nativeShare: function nativeShare(photoId, caption) {
      if (navigator.share) {
        navigator.share({
          title: 'with a view',
          text: 'Share beautiful views !',
          url: 'https://app.withaview.co/ext?id=' + photoId
        }).then(function () {
          console.log('Successful share');
          vm.$store.commit('snackbar_alert', {
            msg: 'Successful share'
          });
        }).catch(function (error) {
          console.log('Error sharing', error);
          vm.$store.commit('snackbar_alert', {
            msg: 'Error sharing' + error
          });
        });
      } else {
        console.log('share not avaailable.');
        this.$store.state.gen.sheet = true;
      }
    },

    // /native share
    // share
    share: function share(photoId, caption) {
      console.log('calling share', photoId, caption);
      this.$store.state.gen.share_photoId = photoId;
      this.$store.state.gen.share_caption = caption;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_identifyOS__["a" /* identifyOS */])() === 'Android') {
        //alert('isCrome=>', isChrome())
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_identifyOS__["c" /* isChrome */])()) {
          this.nativeShare(photoId, caption);
        } else {
          this.$store.state.gen.sheet = true;
        }
      } else {
        this.$store.state.gen.sheet = true;
      }
    }
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _index_mon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _index_dur; });
var _index_mon = function _index_mon(_mon) {
  switch (_mon) {
    case "01":
      return "January";
    case "02":
      return "February";
    case "03":
      return "March";
    case "04":
      return "April";
    case "05":
      return "May";
    case "06":
      return "June";
    case "07":
      return "July";
    case "08":
      return "August";
    case "09":
      return "September";
    case "10":
      return "October";
    case "11":
      return "November";
    case "12":
      return "December";
  }
};

var _index_dur = function _index_dur(_time) {
  var __dur = void 0;
  if (_time < 4) __dur = "Late night";else if (_time < 7) __dur = "Early morning";else if (_time < 10) __dur = "Morning";else if (_time < 12) __dur = "Before noon";else if (_time < 16) __dur = "Afternoon";else if (_time < 18) __dur = "Later afternoon";else if (_time < 25) __dur = "Evening";
  return __dur;
};

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(523),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2aea0327",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(20)(
  /* script */
  null,
  /* template */
  __webpack_require__(522),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24674558",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, exports) {

module.exports = {
cuurent_domain: "https://app.viewzzz.com",

// foursquare credentials
fs_client_id: 'NRLCPVL0ZVF4IOHFOH2YF54NSI0XQXR3B5K1FBII3VAPQ3MZ',
fs_client_secret: 'PGOSMOSDMGUWPGX4C5F53QATPEXDPC3QCEPEA5H01X0YICFV',
fs_redirectUrl: 'https://app.viewzzz.com/?loc=Worldwide',
fs_version: '20200728',

// firebase development
// apiKey: "AIzaSyCAuUeTdGQXpiV_2xru-pX4460Er0yK-Do",
// authDomain: "dev-wav.firebaseapp.com",
// databaseURL: "https://dev-wav.firebaseio.com",
// projectId: "dev-wav",
// storageBucket: "dev-wav.appspot.com",
// messagingSenderId: "170508625596",
// storageBucket:'dev-wav.appspot.com',

// firebase production
apiKey: "AIzaSyAOv2-dENsFi4tjhgMnr_pWFViDZ9fIxnY",
authDomain: "app.withaview.co",
databaseURL: "https://prod-eu-wav.firebaseio.com",
projectId: "prod-eu-wav",
storageBucket: "prod-eu-wav.appspot.com",
messagingSenderId: "615026429269",
appId: "1:615026429269:web:abb4aaec25e891ad0ab3dc",
measurementId: "G-M8G98775ZW",

// cloudinary developement
// cloudinary_cloudName: 'dayeblttk',
// cloudinary_apiKey: '616728461466718',
// cloudinary_apiSecret: 'RYMOwH4OAk0e7AEAh12xxMysweM',
// cloudinary_preset:'v1596539510',
// cloudinary_settings:'f_auto,fl_lossy,q_auto,dpr_auto,e_improve',

//cloudinary production
cloudinary_cloudName: 'xviewzzzx',
cloudinary_apiKey: '194857481468858',
cloudinary_apiSecret: 'LkdKocQmShIEArwY3VGlfMU2VZE',
cloudinary_preset:'v1540590871',
cloudinary_settings:'f_auto,fl_lossy,q_auto,dpr_auto,e_improve',

// imagga
imagga_apiKey: 'acc_7fdfd505c280e6a',
imagga_apiSecret: '7c93985c839156d62fdb2962c8c664e2',

//elastic search production
elasticSearch_url: 'http://35.234.105.166//elasticsearch/',
elasticSearch_username: 'user',
elasticSearch_password: 'dow17wJaxSiG',

// elasticSearch development
// elasticSearch_url: 'http://104.155.44.142//elasticsearch/',
// elasticSearch_username: 'user',
// elasticSearch_password: 'dow17wJaxSiG',

//flickr auth string
flickr_authString: '2d1f30e315009f177afe67162a2211b7',

//google APIs
googleVision_apiKey: 'AIzaSyCDm0m7yKThLUaBvYwM2sGCb-7zsX2n79I'

};

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_platform__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_maintainer__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_maintainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_maintainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_app_css__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_bottomMenu__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_bottomMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_bottomMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_loaders_fullscreenLoader__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_loaders_fullscreenLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_loaders_fullscreenLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_alert_snackbar_alert__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_alert_snackbar_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_alert_snackbar_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_header_header__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_header_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_header_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_auth_verifyEmail__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_auth_verifyEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_auth_verifyEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helper_gen__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixin_imageLinks__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__configurations__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__configurations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__configurations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helper_identifyFirstVisit__ = __webpack_require__(264);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//


//import {ele} from '@/helper/gen'


//








//


var vm = void 0;
var cloudinarySettings = __WEBPACK_IMPORTED_MODULE_13__configurations___default.a.cloudinary_settings;
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixin_imageLinks__["a" /* default */]],
  data: function data() {
    return {
      maintainer: false,
      screenH: 0,
      screenW: 0,
      show_passcode_screen: true,
      test_password_input_type: "password",
      test_password: "",
      currentQuote: {
        author: "",
        text: ""
      },
      tiles: [{
        img: "/static/img/wav-what'sapp-icon.svg",
        title: "Whatsapp",
        func: function func() {
          window.open("https://wa.me/?text=" + __WEBPACK_IMPORTED_MODULE_13__configurations___default.a.currentDomain + "/id/" + vm.$store.state.gen.share_photoId);
        }
      }, {
        img: "/static/img/wav-twitter-icon.svg",
        title: "Twitter",
        func: function func() {
          window.open("http://twitter.com/share?text=Viewzzz&url=" + __WEBPACK_IMPORTED_MODULE_13__configurations___default.a.currentDomain + "/id/" + vm.$store.state.gen.share_photoId);
        }
      }, {
        img: "/static/img/wav-fb-icon.svg",
        title: "Facebook",
        func: function func() {
          window.open("https://www.facebook.com/sharer/sharer.php?u=" + __WEBPACK_IMPORTED_MODULE_13__configurations___default.a.currentDomain + "/id/" + vm.$store.state.gen.share_photoId);
        }
      }],
      quotes: [{
        author: "Lao Tzu",
        text: "A good traveler has no fixed plans, and is not intent on arriving."
      }, {
        author: "Michael Bassey Johnson",
        text: "A good traveler is one who knows how to travel with the mind."
      }, {
        author: "Tim Cahill",
        text: "A journey is best measured in friends rather than miles."
      }, {
        author: "John Steinbeck",
        text: "A journey is like marriage. The certain way to be wrong is to think you control it."
      }, {
        author: "Lao Tzu",
        text: "A journey of a thousand miles begins with a single step."
      }, {
        author: "John A. Shedd",
        text: "A ship in a harbor is safe, but it not what ships are built for."
      }, {
        author: "Aesop",
        text: "Adventure is worthwhile."
      }, {
        author: "Unknown",
        text: "Adventure may hurt you but monotony will kill you."
      }, {
        author: "Martin Buber",
        text: "All journeys have secret destinations of which the traveler is unaware."
      }, {
        author: "JRR Tolkien",
        text: "All that is gold does not glitter; just as not all those who wander are lost."
      }, {
        author: "Wolf, an Appalachian Trail Hiker",
        text: "All you need to know is that it’s possible."
      }, {
        author: "Unknown",
        text: "Better to see something once than hear about it a thousand times."
      }, {
        author: "Lovelle Drachman",
        text: "Blessed are the curious for they shall have adventures."
      }, {
        author: "Unknown",
        text: "Collect Moment, Not Things."
      }, {
        author: "Unknown",
        text: "Dare to live the life you’ve always wanted."
      }, {
        author: "Ralph Waldo Emerson",
        text: "Do not follow where the path may lead. Go instead where there is no path and leave a trail."
      }, {
        author: "Shane L. Koyczan",
        text: "Don’t let your luggage define your travels, each life unravels differently."
      }, {
        author: "Unknown",
        text: "Don’t listen to what they say. Go see."
      }, {
        author: "Mohammed",
        text: "Don’t tell me how educated you are, tell me how much you have traveled."
      }, {
        author: "Ma Jian",
        text: "Everything I was I carry with me, everything I will be lies waiting on the road ahead."
      }, {
        author: "Unknown",
        text: "Go, fly, roam, travel, voyage, explore, journey, discover, adventure."
      }, {
        author: "William Blake",
        text: "Great things are done when men and mountains meet."
      }, {
        author: "Mary Anne Radmacher",
        text: "I am not the same having seen the moon shine on the other side of the world."
      }, {
        author: "Paulo Coelho",
        text: "I can speak to my soul only when the two of us are off exploring deserts or cities or mountains or roads."
      }, {
        author: "Mark Twain",
        text: "I have found out that there ain’t no surer way to find out whether you like people or hate them than to travel with them."
      }, {
        author: "Susan Sontag",
        text: "I haven’t been everywhere, but it’s on my list."
      }, {
        author: "Derek Walcott",
        text: "I read; I travel; I become."
      }, {
        author: "Thomas Jefferson",
        text: "I think one travels more usefully when they travel alone because they reflect more."
      }, {
        author: "Caskie Stinnett",
        text: "I travel a lot; I hate having my life disrupted by routine."
      }, {
        author: "Carew Papritz",
        text: "I travel because it makes me realize how much I haven’t seen, how much I’m not going to see, and how much I still need to see."
      }, {
        author: "Roman Payne",
        text: "I wandered everywhere, through cities and countries wide. And everywhere I went, the world was on my side."
      }, {
        author: "A. Redmerski",
        text: "I wonder if the ocean smells different on the other side of the world."
      }, {
        author: "John Green",
        text: "I’m in love with cities I’ve never been to and people I’ve never met."
      }, {
        author: "Santosh Kalwar",
        text: "If life is a journey then let my soul travel and share your pain."
      }, {
        author: "James Michener",
        text: "If you reject the food, ignore the customs, fear the religion and avoid the people, you might better stay at home."
      }, {
        author: "Paul Coelho",
        text: "If you think adventures are dangerous, try routine: It’s Lethal."
      }, {
        author: "Unknown",
        text: "In the end, we only regret the chances we didn’t take."
      }, {
        author: "Unknown",
        text: "It feels good to be lost in the right direction."
      }, {
        author: "Ursula K. Le Guin",
        text: "It is good to have an end to journey toward, but it is the journey that matters in the end."
      }, {
        author: "Henry David Thoreau",
        text: "It’s not what you look at that matters. It’s what you see."
      }, {
        author: "Helen Keller",
        text: "Life is either a daring adventure or nothing at all."
      }, {
        author: "Unknown",
        text: "Life is short and the world is wide."
      }, {
        author: "Benjamin Disraeli",
        text: "Like all great travelers, I have seen more than I remember, and remember more than I have seen."
      }, {
        author: "Oscar Wilde",
        text: "Live life with no excuses, travel with no regret."
      }, {
        author: "Stephen Covey",
        text: "Live your life by a compass not a clock."
      }, {
        author: "Tennessee Williams",
        text: "Make voyages. Attempt them. There’s nothing else."
      }, {
        author: "Andre Gide",
        text: "Man cannot discover new oceans unless he has the courage to lose sight of the shore."
      }, {
        author: "Jodi Picoult",
        text: "Maybe you had to leave in order to miss a place; maybe you had to travel to figure out how beloved your starting point was."
      }, {
        author: "Roman Payne",
        text: "Never did the world make a queen of a girl who hides in houses and dreams without traveling."
      }, {
        author: "Amin Maalouf",
        text: "Never hesitate to go far away, beyond all seas, all frontiers, all countries, all beliefs."
      }, {
        author: "Banana Yoshimoto",
        text: "No matter where you are, you’re always a bit on your own, always an outsider."
      }, {
        author: "Lin Yutang",
        text: "No one realizes how beautiful it is to travel until he comes home and rests his head on his old, familiar pillow."
      }, {
        author: "J.R.R. Tolkien",
        text: "Not all those who wander are lost."
      }, {
        author: "Unknown",
        text: "Oh Darling, Let’s Be Adventurers."
      }, {
        author: "Dr. Seuss",
        text: "Oh the places you’ll go."
      }, {
        author: "Dalai Lama",
        text: "Once a year, go someplace you’ve never been before."
      }, {
        author: "Michael Palin",
        text: "Once the travel bug bites there is no known antidote, and I know that I shall be happily infected until the end of my life."
      }, {
        author: "Henry Miller",
        text: "One’s destination is never a place, but a new way of seeing things."
      }, {
        author: "John Steinbeck",
        text: "People don’t take trips, trips take people."
      }, {
        author: "Unknown",
        text: "Quit your job, buy a ticket, get a tan, fall in love, never return."
      }, {
        author: "Roy M. Goodman",
        text: "Remember that happiness is a way of travel – not a destination."
      }, {
        author: "Jack Kerouac",
        text: "So shut up, live, travel, adventure, bless and don’t be sorry."
      }, {
        author: "Erol Ozan",
        text: "Some beautiful paths can’t be discovered without getting lost."
      }, {
        author: "Chief Seattle",
        text: "Take only memories, leave only footprints."
      }, {
        author: "Agnes Repplier",
        text: "The impulse to travel is one of the hopeful symptoms of life."
      }, {
        author: "Dan Eldon",
        text: "The journey is the destination."
      }, {
        author: "T.S. Eliot",
        text: "The journey not the arrival matters."
      }, {
        author: "Anna Quindlen",
        text: "The life you have led doesn’t need to be the only life you have."
      }, {
        author: "Henry David Thoreau",
        text: "The man who goes alone can start today, but he who travels with another must wait till that other is ready."
      }, {
        author: "Wallace Stevens",
        text: "The most beautiful in the world is, of course, the world itself."
      }, {
        author: "G.K. Chesterton",
        text: "The traveler sees what he sees. The tourist sees what he has come to see."
      }, {
        author: "Augustine of Hippo",
        text: "The world is a book and those who do not travel read only one page."
      }, {
        author: "Ralph Waldo Emerson",
        text: "The world makes way for the man who knows where he is going."
      }, {
        author: "Robert Louis Stevenson",
        text: "There are no foreign lands. It is the traveler only who is foreign."
      }, {
        author: "Paulo Coelho",
        text: "This wasn’t a strange place; it was a new one."
      }, {
        author: "Ralph Waldo Emerson",
        text: "Though we travel the world over to find the beautiful, we must carry it with us, or we find it not."
      }, {
        author: "Freya Stark",
        text: "To awaken quite alone in a strange town is one of the pleasantest sensations in the world."
      }, {
        author: "Aldous Huxley",
        text: "To travel is to discover that everyone is wrong about other countries."
      }, {
        author: "Hans Christian Andersen",
        text: "To travel is to live."
      }, {
        author: "Elizabeth Gilbert",
        text: "To travel is worth any cost or sacrifice."
      }, {
        author: "Alex Garland",
        text: "Tourists went on holidays while travelers did something else. They traveled."
      }, {
        author: "Jalaluddin Rumi",
        text: "Travel brings power and love back into your life."
      }, {
        author: "Joe Abercrombie",
        text: "Travel brings wisdom only to the wise. It renders the ignorant more ignorant than ever."
      }, {
        author: "Marty Rubin",
        text: "Travel doesn’t become adventure until you leave yourself behind."
      }, {
        author: "Claire Fontaine",
        text: "Travel empties out everything you’ve into the box called your life, all the things you accumulate to tell you who you are."
      }, {
        author: "David Mitchell",
        text: "Travel far enough, you meet yourself."
      }, {
        author: "Mark Twain",
        text: "Travel is fatal to prejudice, bigotry, and narrow-mindedness."
      }, {
        author: "Miriam Beard",
        text: "Travel is more than the seeing of sights; it is a change that goes on, deep and permanent, in the ideas of living."
      }, {
        author: "Unknown",
        text: "Travel is the only thing you buy that makes you richer."
      }, {
        author: "Thomas Fuller",
        text: "Travel makes a wise man better, and a fool worse."
      }, {
        author: "Gustave Flaubert",
        text: "Travel makes one modest. You see what a tiny place you occupy in the world"
      }, {
        author: "Ibn Battuta",
        text: "Traveling – it leaves you speechless, then turns you into a storyteller."
      }, {
        author: "Gayle Foreman",
        text: "Traveling’s not something you’re good at. It’s something you do. Like Breathing."
      }, {
        author: "Robert Frost",
        text: "Two roads diverged in a wood and I – I took the one less traveled by, and that has made all the difference."
      }, {
        author: "Ray Bradbury",
        text: "We travel for romance, we travel for architecture, and we travel to be lost."
      }, {
        author: "Anonymous",
        text: "We travel not to escape life, but for life not to escape us."
      }, {
        author: "Anais Nin",
        text: "We travel, some of us forever, to seek other states, other lives, other souls."
      }, {
        author: "Hilaire Belloc",
        text: "We wander for distraction but we travel for fulfillment."
      }, {
        author: "Jack Kerouac",
        text: "We wandered in a frenzy and a dream."
      }, {
        author: "Clifton Fadiman",
        text: "When you travel, remember that a foreign country is not designed to make you comfortable. It is designed to make its own people comfortable."
      }, {
        author: "Vera Nazarian",
        text: "Whenever you go on a trip to visit foreign lands or distant places, remember that they are all someone’s home and backyard."
      }, {
        author: "Anita Desai",
        text: "Wherever you go becomes a part of you somehow."
      }, {
        author: "Neil Gaiman",
        text: "Wherever you go, you take yourself with you."
      }, {
        author: "Frank Herbert",
        text: "Without new experiences, something inside of us sleeps. The sleeper must awaken."
      }, {
        author: "Unknown",
        text: "Work, Travel, Save, Repeat."
      }, {
        author: "Kirsten Hubbard",
        text: "You can’t control the past, but you can control where you go next."
      }, {
        author: "George Bernard Shaw",
        text: "I dislike feeling at home when I am abroad."
      }, {
        author: "Henry David Thoreau",
        text: "Not until we are lost do we begin to understand ourselves."
      }, {
        author: "Mohamed",
        text: "Don’t tell me how educated you are, tell me how much you travelled."
      }, {
        author: "Kurt Vonnegut",
        text: "Bizarre travel plans are dancing lessons from God."
      }, {
        author: "Martin Buber",
        text: "All journeys have secret destinations of which the traveller is unaware."
      }, {
        author: "Paul Theroux",
        text: "Tourists don’t know where they’ve been, travellers don’t know where they’re going."
      }, {
        author: "Robert Louis Stevenson",
        text: "There are no foreign lands. It is the traveller only who is foreign."
      }, {
        author: "Albert Einstein",
        text: "I love to travel, but hate to arrive."
      }, {
        author: "Hilaire Belloc",
        text: "We wander for distraction, but we travel for fulfillment."
      }, {
        author: "Benjamin Disraeli",
        text: "Travel teaches toleration."
      }, {
        author: "Ray Bradbury",
        text: "Half of the fun of travel is the aesthetic of lostness."
      }, {
        author: "Ben Francia",
        text: "Great things never came from comfort zones."
      }, {
        author: "Maya Angelou",
        text: "If you are always trying to be normal, you will never know how amazing you can be."
      }, {
        author: "Unknown",
        text: "Fear is only temporary. Regrets last forever."
      }, {
        author: "Neale Donald Walsch",
        text: "Life begins at the end of your comfort zone."
      }, {
        author: "David McCullough Jr.",
        text: "Climb the mountain so you can see the world, not so the world can see you."
      }, {
        author: "Alexander Sattler",
        text: "I would rather own a little and see the world than own the world and see a little of it."
      }, {
        author: "William Langewiesche",
        text: "So much of who we are is where we have been."
      }, {
        author: "Paulo Coelho",
        text: "Travel is never a matter of money but of courage."
      }, {
        author: "Shakespeare",
        text: "The earth has music for those who listen."
      }, {
        author: "Unknown",
        text: "Do more things that make you forget to check your phone."
      }, {
        author: "Carew Papritz",
        text: "I travel because I become uncomfortable being too comfortable."
      }, {
        author: "Peter McWilliams",
        text: "Nothing adventured, nothing attained."
      }, {
        author: "Seth Godin",
        text: "If it scares you, it might be a good thing to try."
      }, {
        author: "Franklin D. Roosevelt",
        text: "Above all, try something."
      }, {
        author: "Unknown",
        text: "Good things come to those who book flights."
      }, {
        author: "Edith Wharton",
        text: "One of the great things about travel is that you find out how many good, kind people there are."
      }, {
        author: "Unknown",
        text: "If you look like your passport photo, you probably need the trip."
      }, {
        author: "Rachel Wolchin",
        text: "If we were meant to stay in one place, we’d have roots instead of feet."
      }, {
        author: "Unknown",
        text: "My favourite thing is to go where I’ve never been."
      }, {
        author: "Unknown",
        text: "It’s bad manners to keep an adventure waiting."
      }, {
        author: "Ray Bradbury",
        text: "We travel for romance, we travel for architecture, we travel to be lost."
      }, {
        author: "Ernest Hemingway",
        text: "Never go on trips with anyone you do not love."
      }, {
        author: "Unknown",
        text: "Some things weren’t meant to be tamed. For example, YOU."
      }, {
        author: "Ben Franklin",
        text: "Either write something worth reading or do something worth writing."
      }, {
        author: "John Steinbeck",
        text: "I wonder how many people I’ve looked at all my life and never seen."
      }, {
        author: "Unknown",
        text: "May you never be too busy to stop and breathe under a palm tree."
      }, {
        author: "Unknown",
        text: "Don’t quit your daydream."
      }, {
        author: "Ernest Hemingway",
        text: "The best way to find out if you can trust somebody is to trust them."
      }, {
        author: "Winston Churchill",
        text: "I like things to happen. And if they don’t happen, I like to make them happen."
      }, {
        author: "Unknown",
        text: "Surround yourself with people who get it."
      }, {
        author: "Terry Pratchett",
        text: "Coming back to where you started is not the same as not leaving."
      }, {
        author: "Paul Theroux",
        text: "Travel is glamorous only in retrospect."
      }, {
        author: "Aerin Lauder",
        text: "To understand what’s going on in the world, you have to see the world."
      }, {
        author: "Ugo Eze",
        text: "Be careful who you make memories with. Those things can last a lifetime."
      }, {
        author: "Walt Whitman",
        text: "Not I, not anyone else, can travel that road for you. You must travel it for yourself."
      }, {
        author: "Shanti",
        text: "At the end of the day, your feet should be dirty, your hair should be messy and your eyes sparkling."
      }, {
        author: "Your Passport",
        text: "You’ll never know until you go."
      }, {
        author: "Unknown",
        text: "Travelling is about finding those things that you never knew you were looking for."
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(["getLocationFinal", "addToWishlish"]), {
    openInTab: function openInTab(link) {
      console.log(link);
      window.open(link, "_blank");
    },
    getQuotes: function getQuotes() {
      var x = Math.floor(Math.random() * this.quotes.length);
      this.currentQuote = this.quotes[x];
    },
    saveLocAllowedInLs: function saveLocAllowedInLs() {
      localStorage.setItem("isLocationEnabled", "y");
    },
    verify_test_password: function verify_test_password(password) {
      var passwords = ["qwezxc", "viewz5"];
      if (passwords.includes(password)) {
        console.log("Good to go.");
        localStorage.setItem("_p", "_");
        this.show_passcode_screen = false;
      } else {
        console.log("wrong passcode :/ ");
        this.$store.commit("snackbar_alert", {
          msg: "Incorrect Passcode !"
        });
      }
    }
  }),
  //
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(["showOverlay", "dbRefLoader", "user", "isLoggedIn", "authLoader", "forceRouteLoader", "isbottomMenuOpen", "opencw"])),
  //
  components: {
    maintainer: __WEBPACK_IMPORTED_MODULE_3__components_maintainer___default.a,
    fullscreenLoader: __WEBPACK_IMPORTED_MODULE_7__components_loaders_fullscreenLoader___default.a,
    snackbar_alert: __WEBPACK_IMPORTED_MODULE_8__components_alert_snackbar_alert___default.a,
    customHeader: __WEBPACK_IMPORTED_MODULE_9__components_header_header___default.a,
    verifyEmail: __WEBPACK_IMPORTED_MODULE_10__components_auth_verifyEmail___default.a,
    bottomMenu: __WEBPACK_IMPORTED_MODULE_5__components_common_bottomMenu___default.a
  },
  //
  updated: function updated() {
    /*this.$store.dispatch('getLoginStatus').then((isLoggedIn)=>{
        // once auth is resolved, call this auth dependent function
        console.log("[isLoggedIn] => ", isLoggedIn)
        //
        /* this.$store.commit('forceRoute', {
          routeName: this.$route.name
        })*/
    // })
  },
  created: function created() {
    vm = this;
    //
    /* setTimeout (()=>{
        this.$modal.show('ask-to-add-to-wishlist')
      },5000) */
    window.thisOfApp = this;
    if (localStorage.getItem("_isFirstVisit") != null && screen.width < 600) {
      this.showOnboardings = false;
    } else {
      this.showOnboardings = false;
    }
    // i am send test call to apis here !
    // testing: 1st query custom list.
    /* this.$store.commit('getCustomList', {
        customList: 'testberlin',
        isFirstQuery: true,
        limit: 2,
        startAt: 0
      }) */
    //
    var _isFirstVisit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helper_identifyFirstVisit__["a" /* isFirstVisit */])();
    this.$store.state.gen._isFirstVisit = _isFirstVisit;
    //
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helper_identifyFirstVisit__["b" /* setFirstVisit */])();
    //
    //
    // check passcode
    var _isPasscodeEntered = localStorage.getItem("_p");
    if (_isPasscodeEntered === null) {
      // show enter passcode screen
      this.show_passcode_screen = false; //true
    } else {
      // hideenter passcode screen
      this.show_passcode_screen = false;
    }
    // /check passcode
  },
  mounted: function mounted() {
    var _this = this;

    this.screenW = screen.width;
    this.screenH = screen.height;
    setTimeout(function () {
      //console.log('isUpdateAvailable?=>',localStorage.getItem("isUpdateAvailable"))
      var version = localStorage.getItem("isUpdateAvailable");
      //
      if (version == "YES") {
        _this.$store.commit("snackbar_alert", {
          msg: "New version available!!! Please RELOAD for best experience."
        });
      } else {}
      // nothing

      //
    }, 6000);
    //
  },

  watch: {
    "$store.state.common.swichModesBG": function $storeStateCommonSwichModesBG() {
      var ele = document.getElementsByClassName("container-switch-modes")[0];
      console.log("MODE ELE", ele);
      if (!vm.$store.state.common.swichModesBG) {
        TweenMax.to(ele, 1, { top: "-50vh" });
      } else {
        TweenMax.to(ele, 1, { top: "3.5em" });
      }
    },
    show_passcode_screen: {
      handler: function handler() {
        var _this2 = this;

        //alert(this.show_passcode_screen)
        if (this.show_passcode_screen === false) {
          //alert(this.show_passcode_screen)
          setTimeout(function () {
            if (_this2.$router.currentRoute.query.loc === "Elsewhere") {
              setTimeout(function () {
                _this2.$store.state.gen.showLoader = false;
              }, 5);
              //alert(`920`)
              vm.$store.commit("getElsewherePics", {
                limit: _this2.$store.state.hello.limit,
                startAt: 0
              });
            } else if (_this2.$router.currentRoute.query.loc === "Berlin") {
              setTimeout(function () {
                _this2.$store.state.gen.showLoader = false;
              }, 5);
              // Berlin
              //alert(`932`)
              _this2.$store.commit("getMainScreenImages", {
                query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ testamp: ["testberlin"] }),
                startAt: 0,
                limit: _this2.$store.state.hello.limit,
                uid: _this2.$store.state.auth.user.uid,
                isLoggedIn: _this2.$store.state.auth.isLoggedIn
              });
            }
            //
          }, 10);
        }
      }
    },
    "$store.state.gen.opencw": function $storeStateGenOpencw() {
      if (!vm.$store.state.gen.opencw) {
        console.log("closing dialog, distroy upload widget");
        //
        document.getElementById("inline_container").innerHTML = "";
        //
      }
    }
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//
var vm = void 0;
//
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      line1: '',
      line2: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['snackbar_alert_msg'])),
  methods: {
    msgText: function msgText() {
      vm = this;
      //
      var msg = this.$store.state.gen.snackbar_alert_msg;
      console.log('alert message: ', msg);
      //alert(msg)
      if (msg.includes('Please sign-in to add to your travel list')) {
        //alert(`1`)
        this.line1 = 'Please sign in to complete your desired action.';
        this.line2 = '';
      } else if (msg.includes('Please sign-in to like it.')) {
        //alert(`2`)
        this.line1 = 'Please sign in to complete your desired action.';
        this.line2 = '';
      } else if (msg.includes('Please sign-in to complete this action.')) {
        //alert(`3`)
        this.line1 = 'Please sign in to complete your desired action.';
        this.line2 = '';
      } else {
        this.line1 = msg;
        this.line2 = '';
      }
      //
    }
  },
  watch: {
    '$store.state.gen.showSnack': function $storeStateGenShowSnack() {
      //alert(`0`)
      if (vm.$store.state.gen.showSnack) {
        vm.msgText();
      }
    }
  },
  created: function created() {
    vm = this;
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebaseConfig_js__ = __webpack_require__(73);

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FacebookAuth',
  data: function data() {
    return {
      PARENT_FRAME: document.location.ancestorOrigins[0],
      auth: null
    };
  },
  created: function created() {
    if (!__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].apps.length) {
      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].initializeApp(__WEBPACK_IMPORTED_MODULE_3__firebaseConfig_js__["a" /* default */]);
    }
    this.auth = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth();
  },
  mounted: function mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },

  methods: {
    sendResponse: function sendResponse(result) {
      window.parent.postMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result), this.PARENT_FRAME);
    },
    handleMessage: function handleMessage(_ref) {
      var data = _ref.data;

      if (data.initAuth) {
        var provider = new __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth.FacebookAuthProvider();
        this.auth.signInWithPopup(provider).then(this.sendResponse).catch(this.sendResponse);
      }
    }
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebaseConfig_js__ = __webpack_require__(73);

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GoogleAuth',
  data: function data() {
    return {
      PARENT_FRAME: document.location.ancestorOrigins && document.location.ancestorOrigins[0] ? document.location.ancestorOrigins[0] : '*', // Fallback to '*' if ancestorOrigins isn't available
      auth: null
    };
  },
  created: function created() {
    if (!__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].apps.length) {
      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].initializeApp(__WEBPACK_IMPORTED_MODULE_3__firebaseConfig_js__["a" /* default */]);
    }
    this.auth = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth();
  },
  mounted: function mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },

  methods: {
    // Send response back to the parent frame with proper origin
    sendResponse: function sendResponse(result) {
      if (this.PARENT_FRAME) {
        // Make sure the result is serialized to a string
        // window.parent.postMessage(JSON.stringify(result), this.PARENT_FRAME);
        window.parent.postMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result), '*');
      }
    },

    // Handle messages received from the parent frame
    handleMessage: function handleMessage(_ref) {
      var _this = this;

      var data = _ref.data;

      try {
        if (data && data.initAuth) {
          // Initiate Google Authentication
          var provider = new __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth.GoogleAuthProvider();
          this.auth.signInWithPopup(provider).then(function (userCredential) {
            // Send successful response
            _this.sendResponse({ success: true, user: userCredential.user });
          }).catch(function (error) {
            // Send error response
            _this.sendResponse({ success: false, error: error.message });
          });
        }
      } catch (error) {
        console.error('Error processing message:', error.message);
        this.sendResponse({ success: false, error: error.message });
      }
    }
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_extension_firebaseConfig__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(21);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      errorMessage: null,
      isSignedIn: false,
      loading: true
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _this.initializeFirebase();
              _context.next = 4;
              return _this.handleEmailSignIn();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    initializeFirebase: function initializeFirebase() {
      if (!__WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].apps.length) {
        __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].initializeApp(__WEBPACK_IMPORTED_MODULE_4__browser_extension_firebaseConfig__["a" /* default */]);
      }
    },
    handleEmailSignIn: function handleEmailSignIn() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var auth, email, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                auth = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth();
                email = _this2.getEmailForSignIn();

                if (email) {
                  _context2.next = 5;
                  break;
                }

                _this2.promptForEmail();
                return _context2.abrupt('return');

              case 5:
                _context2.prev = 5;
                _context2.next = 8;
                return auth.signInWithEmailLink(email, window.location.href);

              case 8:
                result = _context2.sent;

                console.log('User signed in successfully:', result.user);

                _this2.isSignedIn = true;
                _context2.next = 13;
                return _this2.redirectToProfile();

              case 13:
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](5);

                _this2.handleSignInError(_context2.t0);

              case 18:
                _context2.prev = 18;

                _this2.loading = false;
                return _context2.finish(18);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 15, 18, 21]]);
      }))();
    },
    getEmailForSignIn: function getEmailForSignIn() {
      // Use email stored locally or prompt if missing
      // get query parameters email
      var email = new URLSearchParams(window.location.search).get('email');
      return window.localStorage.getItem('emailForSignIn') || email || "";
    },
    promptForEmail: function promptForEmail() {
      var email = prompt('Please provide your email for confirmation');
      if (email) {
        window.localStorage.setItem('emailForSignIn', email);
      }
    },
    redirectToProfile: function redirectToProfile() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var userCustomToken;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this3.getUserProfileDetails();

              case 3:
                userCustomToken = _context3.sent;

                // 
                console.log('Custom User Token:', userCustomToken);

                // Redirect after 5 seconds
                _this3.$router.push('/profile?userTokenFirebase=' + userCustomToken);

                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.error('Error fetching profile details:', _context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8]]);
      }))();
    },
    getUserProfileDetails: function getUserProfileDetails() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var user, uid, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                user = __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().currentUser;
                uid = user ? user.uid : null;
                _context4.prev = 2;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__api__["a" /* createCustomToken */], { uid: uid });

              case 5:
                response = _context4.sent;

                console.log("RESULT", response.data); // Log only the data
                return _context4.abrupt('return', response.data.token);

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](2);

                console.error('Error fetching profile details:', _context4.t0);
                throw new Error('Failed to fetch user profile details.');

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[2, 10]]);
      }))();
    },
    handleSignInError: function handleSignInError(error) {
      this.isSignedIn = false;
      this.errorMessage = 'Error completing sign-in.';
      console.error('Error completing sign-in:', error);
    },
    toggleSignIn: function toggleSignIn() {
      var _this5 = this;

      if (this.isSignedIn) {
        __WEBPACK_IMPORTED_MODULE_2_firebase_app__["a" /* default */].auth().signOut().then(function () {
          _this5.isSignedIn = false;
        });
      } else {
        this.handleEmailSignIn();
      }
    }
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//
/* harmony default export */ __webpack_exports__["default"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['resendEmailVerficationLink']))
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_identifyOS__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_share__ = __webpack_require__(213);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var vm = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixin_share__["a" /* default */]],
  data: function data() {
    return {
      iconsRight: [{
        icon: 'location_on',
        content: 'Check-ins',
        color: '#ffffff',
        func: ''
      }, {
        icon: 'favorite',
        content: 'Wishlist',
        color: '#ffffff',
        func: ''
      }, {
        icon: 'add_a_photo',
        content: 'Add new photo',
        func: function func() {
          console.log('open upload img popup.');
        },
        id: 'upload'
      }],
      iconsFoot: [{
        icon: 'zoom_out_map',
        content: 'Fullscreen',
        color: '#febd35',
        func: ''
      }, {
        icon: 'map',
        content: 'Map',
        color: '#ffffff',
        func: ''
      }, {
        icon: 'view_day',
        content: 'List',
        color: '#ffffff',
        func: ''
      }, {
        icon: 'clear',
        content: 'Close',
        color: '#000000',
        func: this.closeBottom
      }],
      os: null,
      desktop: null,
      browser: null
    };
  },

  methods: {
    goToUpload: function goToUpload() {
      //alert(this.$store.state.auth.isLoggedIn)
      if (this.$store.state.auth.isLoggedIn) {
        //alert(`0`)
        this.$router.push('/upload-0');
      } else {
        //alert(`1`)
        this.$router.push('/login');
        this.$store.commit('snackbar_alert', {
          msg: 'Please sign-in to complete this action. It takes only a few seconds.'
        });
      }
    },
    goToHome: function goToHome(mode) {
      console.log('GO HOME', mode);
      if (mode != null) {
        // if(screen.width < 600){
        this.$store.state.common.isModeSwipe = mode;
        var ls = JSON.parse(localStorage.getItem('homePageImages'));
        if (ls != null) {
          ls.isModeSwipe = this.$store.state.common.isModeSwipe;
          localStorage.setItem('homePageImages', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(ls));
        }

        // }
        // true > full screen, false > list view
        // this.$store.state.common.isbottomMenuOpen = false
        this.$router.push({
          path: '/',
          query: {
            loc: this.$route.query.loc !== undefined ? this.$route.query.loc : ls.lastSelectedQuery
          }
        });
      } else {
        var lastSelectedQuery = JSON.parse(localStorage.getItem('homePageImages'));
        this.$router.push({
          path: '/map',
          query: {
            loc: this.$route.query.loc !== undefined ? this.$route.query.loc : lastSelectedQuery.lastSelectedQuery
          }
        });
      }
    },
    closeModel: function closeModel() {
      var vm = this;
      var modal = document.getElementById('model');
      window.onclick = function (event) {
        if (event.target == modal) {
          vm.$store.state.common.isbottomMenuOpen = false;
        }
      };
    },
    closeBottom: function closeBottom() {
      this.$store.state.common.isbottomMenuOpen = false;
    },
    goToProfile: function goToProfile(selectedProfileTab) {
      console.log('GO TO PROFILE, isLoggedIn: ', this.$store.state.auth.isLoggedIn);

      if (!this.$store.state.auth.isLoggedIn) {
        // check if logged in
        this.$store.state.common.isbottomMenuOpen = false;
        this.$store.commit('snackbar_alert', {
          msg: 'Please sign-in to complete this action. It takes only a few seconds.'
        });
        this.$router.push({
          path: '/login'
        });
      } else {

        if (selectedProfileTab === 'Wishlist') {
          this.$router.push('/profile?selected_tab=wishlist');
          this.$store.state.common.isbottomMenuOpen = false;
        } else if (selectedProfileTab === 'Person') {
          this.$router.push('/profile?selected_tab=shared');
          this.$store.state.common.isbottomMenuOpen = false;
        } else if (selectedProfileTab === 'Check-ins') {
          this.$router.push('/profile?selected_tab=check-ins');
          this.$store.state.common.isbottomMenuOpen = false;
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isModeSwipe']), {
    screenW: function screenW() {
      return screen.width;
    },
    selectedMode: function selectedMode() {
      if (this.isModeSwipe) {
        return 'Fullscreen';
      } else {
        return 'List';
      }
    }
  }),
  mounted: function mounted() {
    //this.$store.commit('uploadImage_1')
    vm = this;
    this.os = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_identifyOS__["a" /* identifyOS */])();
    this.desktop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_identifyOS__["b" /* identifyDesktop */])();
    this.browser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_identifyOS__["c" /* isChrome */])();
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//
/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['user', 'isLoggedIn', 'appName'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['logout', 'goTo'])),
  created: function created() {
    window.thisOfHeader = this;
  }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PageIndex',
  methods: {
    goToSocialLink: function goToSocialLink(social) {

      switch (social) {
        case 'fb':
          window.open('https://www.facebook.com/pages/category/Software-Company/Ideeza-222844688569339/');
          break;
        case 'insta':
          window.open('https://www.instagram.com/p/Bl7BbpFnhBZ/?tagged=ideeza');
          break;
        case 'twitter':
          window.open('https://twitter.com/IDEEZA2');
          break;
        case 'in':
          window.open('https://www.linkedin.com/company/ideeza1826/');
          break;
      }
    }
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoginStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_auth_auth__ = __webpack_require__(15);





var getLoginStatus = function getLoginStatus() {
  //
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (res) {
    __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth().onAuthStateChanged(function (user) {
      if (user) {
        //
        __WEBPACK_IMPORTED_MODULE_3__store_modules_auth_auth__["a" /* default */].state.isLoggedIn = true;
        __WEBPACK_IMPORTED_MODULE_3__store_modules_auth_auth__["a" /* default */].state.user = user;
        //
        //
      } else {
        //
        __WEBPACK_IMPORTED_MODULE_3__store_modules_auth_auth__["a" /* default */].state.isLoggedIn = false;
        __WEBPACK_IMPORTED_MODULE_3__store_modules_auth_auth__["a" /* default */].state.user = {};
        //
      }
      //
      res({
        user: __WEBPACK_IMPORTED_MODULE_3__store_modules_auth_auth__["a" /* default */].state.user,
        isLoggedIn: __WEBPACK_IMPORTED_MODULE_3__store_modules_auth_auth__["a" /* default */].state.isLoggedIn
      }); // return login status
      __WEBPACK_IMPORTED_MODULE_3__store_modules_auth_auth__["a" /* default */].state.authLoader = false;
    });
  });
};

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFirstVisit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setFirstVisit; });
var isFirstVisit = function isFirstVisit() {
  var _isFirstVisit = localStorage.getItem("_isFirstVisit");
  if (_isFirstVisit === null) {
    return true;
  } else {
    return false;
  }
};

var setFirstVisit = function setFirstVisit() {
  localStorage.setItem("_isFirstVisit", "y");
};

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_main_scss__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__firebase_config__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_dist_vuetify_min_css__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_libs_googleFont_css__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_libs_googleFont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_libs_googleFont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_lazyload__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helper_dbRefs__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios_progress_bar__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios_progress_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios_progress_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_js_modal__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_whatwg_fetch__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_fetch__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_meta__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_v_lazy_image__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_v_lazy_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_v_lazy_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_youtube_embed__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuescroll__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuescroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuescroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_date_fns__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_date_fns_addDays__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_axios__);





var _this2 = this;

var get_token = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
                var currentUser, token;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_8_firebase_app__["a" /* default */].auth().currentUser;

                      case 2:
                        currentUser = _context.sent;

                        if (!currentUser) {
                          _context.next = 10;
                          break;
                        }

                        _context.next = 6;
                        return currentUser.getIdToken(true);

                      case 6:
                        token = _context.sent;

                        //return token
                        resolve(token);
                        _context.next = 11;
                        break;

                      case 10:
                        resolve('');
                        //return ''

                      case 11:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function get_token() {
    return _ref.apply(this, arguments);
  };
}();

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

//



//firebase



//store

//
//Vueitify



//

// helper


//modal


// optionally use a fetch polyfill



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_fetch___default.a, {
  polyfill: true //should vue-fetch load promise polyfill, set to false to use customer polyfill
});

//lazy image loader

//

//





__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vuescroll___default.a, {
  ops: {
    bar: {
      background: "#bd10e0",
      gutterOfSide: "2px"
    }
  }
});
;

// vue modal
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_js_modal___default.a);

//
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_lazyload__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_v_lazy_image__["VLazyImagePlugin"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_meta__["a" /* default */], {
  refreshOnceOnNavigation: true
});
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue_youtube_embed__["a" /* default */]);
//
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = false;

var firebaseApp = __WEBPACK_IMPORTED_MODULE_8_firebase_app__["a" /* default */].initializeApp(__WEBPACK_IMPORTED_MODULE_10__firebase_config__["a" /* config */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helper_dbRefs__["a" /* defineDbRefs */])(); // db refs.
__WEBPACK_IMPORTED_MODULE_11__store__["a" /* store */].state.gen.appName = 'Viewzzz';



var _pass = void 0;
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App___default.a },
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__App___default.a);
  },
  store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* store */],
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_axios_progress_bar__["loadProgressBar"])();
  }
});

var curDate = new Date();
var curFullYear = curDate.getFullYear();
var curMonth = curDate.getMonth() + 1;
var curDay = curDate.getDate();
if (curDay < 10) {
  curDay = "0" + curDay;
}
if (curMonth < 10) {
  curMonth = "0" + curMonth;
}
var currentDate = curFullYear + "-" + curMonth + "-" + curDay;
var filterObject = {
  currentDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_date_fns__["a" /* format */])(new Date(), 'yyyy-MM-dd'),
  checkinDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_date_fns__["a" /* format */])(new Date(), 'yyyy-MM-dd'),
  checkoutDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_date_fns__["a" /* format */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_date_fns_addDays__["a" /* default */])(new Date(), 1), 'yyyy-MM-dd'),
  nosOfGuests: 1,
  filtered: false,
  st: ['all'],
  loc: 'worldwide',
  tab: 'all'
};
localStorage.setItem("filterSettings", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterObject));

// req 1 // start loader.
__WEBPACK_IMPORTED_MODULE_27_axios___default.a.interceptors.request.use(function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(config) {
    var token;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return get_token();

          case 2:
            token = _context3.sent;

            if (!config.url.includes('https://maps.googleapis.com')) {
              config.headers['authorization'] = 'Bearer ' + token;
            }

            // LOADER
            if (!config.url.includes('markExposure') && !config.url.includes('operationOnPhoto') && !config.url.includes('getTagSuggestion_uploadImage') && !config.url.includes('maps.googleapis.com') && !config.url.includes('nearby_photo') && !config.url.includes('getParticularPhotoDetails_2') && !config.url.includes('imgDet_top')) __WEBPACK_IMPORTED_MODULE_11__store__["a" /* store */].state.gen.showLoader = true;
            return _context3.abrupt('return', config);

          case 6:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this2);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}());

// req 1 // stop loader.
__WEBPACK_IMPORTED_MODULE_27_axios___default.a.interceptors.response.use(function (config) {
  __WEBPACK_IMPORTED_MODULE_11__store__["a" /* store */].state.gen.showLoader = false;
  return config;
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gen__ = __webpack_require__(4);




var state = {
  emailMagin_login_email: ''
};

var getters = {};

var mutations = {
  //
  emailMagic_login: function emailMagic_login(state2, payload) {
    //
    __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = true;
    //
    var email = state.emailMagin_login_email;
    //

    var actionCodeSettings = {
      // Your redirect URL
      url: window.location.origin + '/complete-signin',
      handleCodeInApp: true
    };

    __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().sendSignInLinkToEmail(email, actionCodeSettings).then(function () {

      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: 'Login link has been sent to your mail: ' + email
      });

      localStorage.setItem('emailForSignIn', email);
      //
      state.emailMagin_login_email = '';

      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = false;
    }).catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // ...
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: error.message
      });
      //
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = false;
      //
    });
    //
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gen__ = __webpack_require__(4);




var state = {
  emailPassword_login_email: '',
  emailPassword_login_password: ''
};

var getters = {};

var mutations = {
  //
  emailPassword_login: function emailPassword_login(state2, payload) {
    //console.log(payload)
    //
    __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = true;
    //
    var email = payload.email;
    var password = payload.password;
    //
    __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().signInWithEmailAndPassword(email, password).then(function () {

      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: 'Logged In Successfully !'
      });
      //
      state.emailPassword_login_email = '';
      state.emailPassword_login_password = '';
      //
      //route
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.goTo(state, '/');
      //
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = false;
    }).catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // ...
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: error.message
      });
      //
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = false;
      //
    });
    //
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emailPassword_otherFunctions__ = __webpack_require__(119);





var state = {
  emailPassword_signup_displayName: '',
  emailPassword_signup_email: '',
  emailPassword_signup_password: ''
};

var getters = {};

var mutations = {
  //
  emailPassword_signup: function emailPassword_signup(state2, payload) {
    console.log(payload);
    //
    var displayName = payload.displayName; //check if empty //
    var email = payload.email;
    var password = payload.password;
    //
    var checkVarsIfEmpty_arr = [];
    checkVarsIfEmpty_arr.push({
      fieldValue: displayName,
      fieldName: 'Name'
    });
    //
    __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].actions.isEmptyField(state, {
      checkVarsIfEmpty_arr: checkVarsIfEmpty_arr
    }).then(function (isEmpty) {
      //console.log("[isEmptyField] => ", result)
      if (!isEmpty) {
        //
        __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = true;
        //
        __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().createUserWithEmailAndPassword(email, password).then(function () {
          //
          var user = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].auth().currentUser;
          //console.log("user => ", user)
          //
          user.updateProfile({
            displayName: displayName
          }).then(function () {
            //console.log("// Update successful. //Display Name")
            //
            state.emailPassword_signup_displayName = '';
            state.emailPassword_signup_email = '';
            state.emailPassword_signup_password = '';
            //
            __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
              msg: 'Account Created Successfully !'
            });
            //
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_3__emailPassword_otherFunctions__["a" /* default */].mutations.resendEmailVerficationLink(state);
            }, 4000);
            //
            window.thisOfHeader.$forceUpdate();
            //
            //route
            __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.goTo(state, '/');
            //
            __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = false;
            //
          }).catch(function (error) {
            // An error happened.
            //console.log(error)
            //
            __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
              msg: error.message
            });
            //
            __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = false;
          });
          //
        }).catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
          __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
            msg: error.message
          });
          //
          __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].state.btnLoader = false;
        });
        //
      }
    });
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(18);









var state = {};

var getters = {};

var mutations = {
  //
  googleLogin: function googleLogin(state) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var provider;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              provider = new __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth.GoogleAuthProvider();

              __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().signInWithPopup(provider).then(function (result) {
                // This gives you a Google Access Token. You can use it to access the Google API.
                var token = result.credential.accessToken;
                // The signed-in user info.
                var user = result.user;
                // ...
                var uid = user.uid;
                // ...
                /*axios.get(newUserAccountSetup, {
                  params: {
                    uid
                  }
                }).then((response)=>{
                  //
                  console.log(`response google login: `, response)
                  //gen.mutations.goTo(state, '/')
                 // if(localStorage.getItem('to').name !== 'null'
                   // || JSON.parse(localStorage.getItem('to')).name !== null) {
                    router.go(-1)
                 // }
                  //
                })*/
                //
                __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].go(-1);
                // localStorage.setItem('uploader', JSON.stringify({"uploader":"user","uploaderId":uid}))
                //
              }).catch(function (error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                alert(errorMessage);

                /* gen.mutations.snackbar_alert(state, {
                   msg: error.message
                 }) */

                // ...
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  fbLogin: function fbLogin(state) {
    console.log('calling fb login');
    var provider = new __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth.FacebookAuthProvider();
    __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().signInWithPopup(provider).then(function (result) {
      // This gives you a Facebook Access Token. You can use it to access the Facebook API.
      var token = result.credential.accessToken;
      // The signed-in user info.
      var user = result.user;
      // ...
      var uid = user.uid;
      // ...
      /*axios.get(newUserAccountSetup, {
        params: {
          uid
        }
      }).then((response)=>{
        //
        console.log(`response google login: `, response)
        //gen.mutations.goTo(state, '/')
        router.go(-1)
        //
      })*/
      //
      __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].go(-1);
      //
    }).catch(function (error) {
      //
      console.log('fb login err: ', error);
      //
      console.log('error msg: ', error.message);
      //
      __WEBPACK_IMPORTED_MODULE_2__gen__["a" /* default */].mutations.snackbar_alert(state, {
        msg: error.message
      });
      //
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });

    /* firebase.auth().getRedirectResult().then(function(result) {
      if (result.credential) {
        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        var token = result.credential.accessToken;
        // ...
        var user = result.user;
        // ...
        console.log(`user: `, user)
        let uid = user.uid
        // ...
        axios.get(newUserAccountSetup, {
          params: {
            uid
          }
        }).then((response)=>{
          //
          console.log(`response google login: `, response)
          //gen.mutations.goTo(state, '/')
          router.go(-1)
          //
        })
      }
      // The signed-in user info.
      var user = result.user;
    }).catch(function(error) {
      console.log('fb login err: ', error)
      // Handle Errors here.
       gen.mutations.snackbar_alert(state, {
        msg: error.message
      })
       var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    }); */
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(21);





var state = {};

var mutations = {
  // get custom list
  getCustomList: function getCustomList(state2, payload) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var customList, limit, startAt, isFirstQuery, response, data, lastQueried;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('getCustomList: ', payload);
              // parse payload
              customList = payload.customList;
              limit = payload.limit;
              startAt = payload.startAt;
              isFirstQuery = payload.isFirstQuery;
              // call api

              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('' + __WEBPACK_IMPORTED_MODULE_3__api__["j" /* getCustomList */], {
                params: {
                  customList: customList,
                  limit: limit,
                  startAt: startAt,
                  isFirstQuery: isFirstQuery
                }
              });

            case 7:
              response = _context.sent;

              // console.log('gotCustomList: ', response)
              data = response.data;
              // console.log('gotCustomList: ', data)
              // all data.

              if (data.size != 0) {
                // last queried data.
                lastQueried = data.docs[data.docs.length - 1];

                console.log('lastQueried: ', lastQueried);
                // see all data.
              }

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  // test function
  testFunction: function testFunction(state, payload) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('' + __WEBPACK_IMPORTED_MODULE_3__api__["k" /* testFunction */]);

            case 2:
              response = _context2.sent;

              // console.log('gotFromTestFunction', response)
              data = response.data;
              // console.log('COMPARE: ', data)

              data.forEach(function (doc) {
                // console.log('1: ', doc.id)
                // console.log('2: ', doc.data())
              });

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);





var actions = {
  getUserAllFilters: function getUserAllFilters(state2, payload) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
        var tag, x1;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tag = payload.tag;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["b" /* getUserAllFilters */])(tag));

              case 3:
                x1 = _context.sent;

                resolve(x1.data.tags);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dbRefs__ = __webpack_require__(55);




var state = {
  query_location: '',
  queried_locations: []
};

var getters = {
  query_location: function query_location(state) {
    return state.query_location;
  },
  queried_locations: function queried_locations(state) {
    return state.queried_locations;
  }
};

var mutations = {
  query_location: function query_location(state2, payload) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // console.log(`query_location: `, {_q: state.query_location})
              //
              __WEBPACK_IMPORTED_MODULE_2__dbRefs__["a" /* default */].state.firestore.collection("addressIndex")
              //.where("showToUser", "==", true) // if show only selected.
              //.orderBy("date")
              //.limit(100) // change limit
              .onSnapshot(function (db_locations) {
                // console.log("Current data: ", db_locations);
                var show_locations = [];
                db_locations.forEach(function (loc) {
                  if (loc.id.toLowerCase().includes(state.query_location.toLowerCase())) {
                    var re = /\d/;
                    var hasNo = re.test(loc.id.toLowerCase());
                    // console.log({ hasNo, loc2: loc.id.toLowerCase(), loc3: loc.data() })
                    if (!hasNo && loc.data().pic_cnt) {
                      if (loc.data().pic_cnt > 0) {
                        var tmp = {
                          name: loc.id,
                          bold: loc.id.toLowerCase() === state.query_location.toLowerCase(),
                          pic_cnt: loc.data().pic_cnt
                        };
                        show_locations.push(tmp);
                      }
                    }
                  }
                });
                state.queried_locations = show_locations;
              });
              //

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_geo_hash__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_geo_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_geo_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_haversine__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_haversine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_haversine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_sha512__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_sha512___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_js_sha512__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configurations__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configurations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__configurations__);














var state = {
  startAt: 0,
  limit: 50, // change limit
  filteredImagesArr: [],
  maxPhotos: 0,
  userGeohash: '',
  tempVar: false,
  fetchingImagesFromDb: false,
  lastVisible: 'first_call',
  fetchedPicsLength: null,
  morePhotos: true,
  flickrImageAvailability: false
};

var getters = {
  tempVar: function tempVar(state) {
    return state.tempVar;
  },
  startAt: function startAt(state) {
    return state.startAt;
  },
  limit: function limit(state) {
    return state.limit;
  },
  filteredImagesArr: function filteredImagesArr(state) {
    return state.filteredImagesArr;
  },
  maxPhotos: function maxPhotos(state) {
    return state.maxPhotos;
  },
  userGeohash: function userGeohash(state) {
    return state.userGeohash;
  },
  fetchedPicsLength: function fetchedPicsLength(state) {
    return state.fetchedPicsLength;
  },
  morePhotos: function morePhotos(state) {
    return state.morePhotos;
  }
};

var mutations = {

  // get Elsewhere
  getElsewherePics: function getElsewherePics(state2, payload) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var d, month, year, date, completeDate, seed, str, i, s2, pics, response, _i, cloudinarySettings, img, link, photoLinkH, photoLinkW, img2, _img, flickrLink, _img2, _img3, _img4, _img5, d1Lon, d1, d2Lon, d2, distance;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //
              if (payload.startAt == 0) {
                state.filteredImagesArr = [];
                state.lastVisible = payload.lastVisible = payload.startAt === 0 ? 'first_call' : state.lastVisible;
              }
              //console.log({USER_GEO: JSON.parse(payload.userGeo)})
              payload.addressIndex = [];
              // payload.lastVisible = state.lastVisible
              state.fetchingImagesFromDb = true;
              payload.isLoggedIn = __WEBPACK_IMPORTED_MODULE_4__auth_auth__["a" /* default */].state.isLoggedIn, payload.uid = __WEBPACK_IMPORTED_MODULE_4__auth_auth__["a" /* default */].state.user.uid, payload.sortBy === undefined ? payload.sortBy = 'random' : payload.sortBy === 'distance' ? payload.userGeo = JSON.parse(payload.userGeo) : delete payload['userGeo'];
              payload.worldwide = true;
              payload.emotionalAppeal = payload.emotionalAppeal;
              payload.spotType = payload.spotType;
              payload.keywords = payload.keywords;
              payload.viewType = payload.viewType;
              // payload.isCron = false,
              // payload.lastVisible = payload.startAt === 0? 'first_call': state.lastVisible
              //
              d = new Date();
              month = d.getMonth();
              year = d.getFullYear();
              date = d.getDate();
              completeDate = date + "-" + month + "-" + year;
              seed = __WEBPACK_IMPORTED_MODULE_10_js_sha512___default()(completeDate);
              str = __WEBPACK_IMPORTED_MODULE_11__api__["m" /* getFilteredPhotos */] + '?';

              for (i in payload) {
                str += i + '=' + (typeof payload[i] !== 'string' ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload[i]) : payload[i]) + '&';
              }
              str += 'seed=' + seed;
              s2 = str.substring(0, str.length - 1);
              _context.next = 21;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(s2);

            case 21:
              pics = _context.sent;

              state.fetchedPicsLength = pics.data.photos.length;
              /*fetch(s2, {
                method: 'GET',
                headers: {
                  'Authorization': 'Bearer' + 'fdsdfsdfs'
                }
              })*/
              //
              // console.log(`pics -> `, pics)
              response = pics.data;

              state.fetchingImagesFromDb = false;

              if (!(response.photos.length !== 0)) {
                _context.next = 41;
                break;
              }

              state.lastVisible = response.photos[response.photos.length - 1].id;
              _context.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(response.photos);

            case 28:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 41;
                break;
              }

              _i = _context.t1.value;

              if (!(response.photos[_i] !== null)) {
                _context.next = 38;
                break;
              }

              //if(common.state.isModeSwipe) {
              cloudinarySettings = __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_settings;
              img = new Image();

              if (response.photos[_i].id !== null) {
                if (response.photos[_i].id.match("^fse")) {
                  link = response.photos[_i].photoSourceLink;
                  photoLinkH = link.replace("original", 'height' + screen.height);
                  photoLinkW = link.replace("original", 'width' + screen.width);

                  img.src = photoLinkH;
                  img.alt = 'image';
                  img2 = new Image();

                  img2.src = photoLinkW;
                  img2.alt = 'image';
                } else if (!!response.photos[_i].propertyLink) {
                  img.src = response.photos[_i].photoSourceLink;
                  img.alt = 'image';
                  _img = new Image();

                  _img.src = response.photos[_i].photoSourceLink;
                  _img.alt = 'image';
                } else {
                  if (!!response.photos[_i].flickrImageLink) {
                    flickrLink = mutations.getFlickrLink(response.photos[_i].flickrImageLink, screen.height);

                    if (mutations.flickrImageLinkAvailable(flickrLink)) {
                      img.src = flickrLink;
                      img.alt = 'image';
                      _img2 = new Image();

                      _img2.src = mutations.getFlickrLink(response.photos[_i].flickrImageLink, screen.width);
                      _img2.alt = 'image';
                    } else {
                      img.src = 'https://res.cloudinary.com/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_cloudName + '/image/upload/h_' + screen.height + ',' + cloudinarySettings + '/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_preset + '/' + response.photos[_i].id;
                      img.alt = 'image';
                      _img3 = new Image();

                      _img3.src = 'https://res.cloudinary.com/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_cloudName + '/image/upload/w_' + screen.width + ',' + cloudinarySettings + '/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_preset + '/' + response.photos[_i].id;
                      _img3.alt = 'image';
                    }
                  } else {
                    if (response.photos[_i].propertyImages) {
                      img.src = response.photos[_i].photoSourceLink;
                      img.alt = 'image';
                      _img4 = new Image();

                      _img4.src = response.photos[_i].photoSourceLink;
                      _img4.alt = 'image';
                    }
                    if (response.photos[_i].uploader === "user") {
                      img.src = 'https://res.cloudinary.com/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_cloudName + '/image/upload/h_' + screen.height + ',' + cloudinarySettings + '/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_preset + '/' + response.photos[_i].id;
                      img.alt = 'image';
                      _img5 = new Image();

                      _img5.src = 'https://res.cloudinary.com/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_cloudName + '/image/upload/w_' + screen.width + ',' + cloudinarySettings + '/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_preset + '/' + response.photos[_i].id;
                      _img5.alt = 'image';
                    }
                  }
                }
              }
              //}
              // img.src = `https://res.cloudinary.com/viewzzz/image/upload/w_auto/v1523306017/${response.photos[i].id}.jpg`

              state.filteredImagesArr.push(response.photos[_i]);
              // console.log('HERE IS GEOHASH', gen.state.finalUserLocation)
              // console.log('NOT IN IF==============>', gen.state.finalUserLocation, response.photos[i].shareSpotLocation.geohash)
              if (__WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].state.finalUserLocation != '' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.photos[_i].shareSpotLocation).length !== 0 && __WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].state.finalUserLocation != undefined && response.photos[_i].shareSpotLocation.geohash != "") {
                // console.log('GOING IN IF :(')
                d1Lon = __WEBPACK_IMPORTED_MODULE_7_geo_hash___default.a.decode(__WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].state.finalUserLocation);
                d1 = { latitude: d1Lon.lat, longitude: d1Lon.lon };
                d2Lon = __WEBPACK_IMPORTED_MODULE_7_geo_hash___default.a.decode(response.photos[_i].shareSpotLocation.geohash);
                d2 = { latitude: d2Lon.lat, longitude: d2Lon.lon };
                distance = __WEBPACK_IMPORTED_MODULE_8_haversine___default()(d1, d2);
                // console.log('DISTANCE=>', distance)

                state.filteredImagesArr[state.filteredImagesArr.length - 1].distance = distance.toFixed(0) + ' km';
              } else {
                state.filteredImagesArr[state.filteredImagesArr.length - 1].distance = '-- km';
              }
              _context.next = 39;
              break;

            case 38:
              return _context.abrupt('break', 41);

            case 39:
              _context.next = 28;
              break;

            case 41:

              state.maxPhotos = state.filteredImagesArr.length;

              //

            case 42:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  flickrImageLinkAvailable: function flickrImageLinkAvailable(photoLink) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.flickrImageAvailability = false;
              _context2.next = 3;
              return fetch(photoLink).then(function (response) {
                if (response.status < 400) {
                  // console.log("Flickr image available");
                  _this2.flickrImageAvailability = true;
                } else if (response.status === 403) {
                  console.error("Flickr image available error");
                  _this2.flickrImageAvailability = false;
                } else if (response.status === 404) {
                  console.error("Flickr image not available");
                  _this2.flickrImageAvailability = false;
                };
              });

            case 3:
              return _context2.abrupt('return', _this2.flickrImageAvailability);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getFlickrLink: function getFlickrLink(photoLink, dimension) {
    if (dimension > 1200 && dimension < 1600) {
      return photoLink.replace("_o.", "_h.");
    } else if (dimension > 1600) {
      return photoLink.replace("_o.", "_k.");
    } else if (dimension < 1200 && dimension > 800) {
      return photoLink.replace("_o.", "_b.");
    } else if (dimension <= 800 && dimension > 640) {
      return photoLink.replace("_o.", "_c.");
    } else if (dimension <= 640) {
      return photoLink.replace("_o.", "_z.");
    }
  },

  // / get Elsewhere

  // async markExposure(state, payload) {
  //   console.log('PAYLOAD of markExposure', payload)
  //   let photoId = payload.id
  //   let uploaderId = payload.uploaderId
  //   let x1 = await axios.get(markExposure, {
  //     params: {
  //       photoId,
  //       uploaderId
  //     }
  //   })
  //   console.log('x1 res from mark exposure', x1)
  // },
  getLocation: function getLocation(state2) {
    __WEBPACK_IMPORTED_MODULE_9__common_common__["a" /* default */].state.fetchLocLoader = true;
    // console.log('CALLING GET LOCATION')
    __WEBPACK_IMPORTED_MODULE_9__common_common__["a" /* default */].state.fetchLocLoader = false;
    for (var i in state.filteredImagesArr) {
      // console.log('HERE IS GEOHASH', gen.state.finalUserLocation)
      // console.log('NOT IN IF==============>',i,  state.userGeohash, state)
      if (__WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].state.finalUserLocation != '' && __WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].state.finalUserLocation != undefined && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.filteredImagesArr[i].shareSpotLocation).length !== 0 && state.filteredImagesArr[i].shareSpotLocation.geohash != "") {
        // console.log('GOING IN IF :(')
        var d1Lon = __WEBPACK_IMPORTED_MODULE_7_geo_hash___default.a.decode(__WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].state.finalUserLocation);
        var d1 = { latitude: d1Lon.lat, longitude: d1Lon.lon };
        var d2Lon = __WEBPACK_IMPORTED_MODULE_7_geo_hash___default.a.decode(state.filteredImagesArr[i].shareSpotLocation.geohash);
        var d2 = { latitude: d2Lon.lat, longitude: d2Lon.lon };

        var distance = __WEBPACK_IMPORTED_MODULE_8_haversine___default()(d1, d2);
        var isM = false;
        if (distance.toFixed(0) === '0') {
          isM = true;
          distance = __WEBPACK_IMPORTED_MODULE_8_haversine___default()(d1, d2, { unit: 'meter' });
        }
        // console.log('DISTANCE=>', distance)
        state.filteredImagesArr[i].distance = distance.toFixed(0) + ' ' + (isM ? ' m' : ' km');
      } else {
        state.filteredImagesArr[i].distance = '-- km';
      }
    }

    window.helloThis.$forceUpdate();
  },


  //
  goTo_uploadImage: function goTo_uploadImage(state) {
    //
    if (!__WEBPACK_IMPORTED_MODULE_4__auth_auth__["a" /* default */].state.isLoggedIn) {
      __WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].mutations.goTo(state, '/Login');
    } else {
      __WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].mutations.goTo(state, '/uploadImage_1');
    }
  },
  getMainScreenImages: function getMainScreenImages(state2, payload) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var str, i, s2, x1, response, _i2, img, link, img2, cloudinarySettings, _img6, _img7, d1Lon, d1, d2Lon, d2, distance, isM;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:

              //alert(`147`)
              // payload.isCron = false
              state.fetchingImagesFromDb = true;
              // mutations.getLocation(state)
              // console.log('FILTER IMAGES=>', state.filteredImagesArr)
              // console.log('1=>', payload)
              //
              payload['isLoggedIn'];
              delete payload['query'];
              payload.sortBy !== 'distance' ? delete payload['userGeo'] : '';
              payload.addressIndex === undefined ? payload.addressIndex = [] : '';
              payload.sortBy === undefined ? payload['sortBy'] = 'random' : payload.sortBy === 'distance' ? payload.userGeo = JSON.parse(payload.userGeo) : delete payload['userGeo'];
              payload.worldwide = false;
              payload.emotionalAppeal = payload.emotionalAppeal;
              payload.spotType = payload.spotType;
              payload.keywords = payload.keywords;

              // console.log('PAYLOAD:', payload)
              // payload.lastVisible = payload.startAt === 0? 'first_call': state.lastVisible
              //
              //let objSTR = JSON.stringify(payload)
              str = __WEBPACK_IMPORTED_MODULE_11__api__["m" /* getFilteredPhotos */] + '?';

              for (i in payload) {
                str += i + '=' + (typeof payload[i] !== 'string' ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload[i]) : payload[i]) + '&';
              }
              s2 = str.substring(0, str.length - 1);
              _context3.next = 15;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(s2);

            case 15:
              x1 = _context3.sent;

              if (payload.startAt == 0) {
                state.filteredImagesArr = [];
                state.lastVisible = 'first_call';
              }
              // console.log('X1=>', x1)
              state.fetchingImagesFromDb = false;
              response = x1.data;

              if (!(response.photos.length !== 0)) {
                _context3.next = 36;
                break;
              }

              state.lastVisible = response.photos[response.photos.length - 1].id;
              state.maxPhotos = response.totalPhotos;
              _context3.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(response.photos);

            case 23:
              if ((_context3.t1 = _context3.t0()).done) {
                _context3.next = 34;
                break;
              }

              _i2 = _context3.t1.value;

              if (!(response.photos[_i2] !== null)) {
                _context3.next = 31;
                break;
              }

              // if(common.state.isModeSwipe) {
              if (response.photos[_i2].id.match('^fse')) {
                img = new Image();
                link = response.photos[_i2].photoSourceLink;

                img.src = link.replace("original", 'width' + screen.height);
                img2 = new Image();

                img2.src = link.replace("original", 'width' + screen.width);
              } else {
                cloudinarySettings = __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_settings;
                _img6 = new Image();

                _img6.src = 'https://res.cloudinary.com/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_cloudName + '/image/upload/h_' + screen.height + ',' + cloudinarySettings + '/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_preset + '/' + response.photos[_i2].id;
                _img7 = new Image();

                _img7.src = 'https://res.cloudinary.com/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_cloudName + '/image/upload/w_' + screen.width + ',' + cloudinarySettings + '/' + __WEBPACK_IMPORTED_MODULE_12__configurations___default.a.cloudinary_preset + '/' + response.photos[_i2].id;
              }
              // }
              state.filteredImagesArr.push(response.photos[_i2]);
              //  console.log('HERE IS GEOHASH', gen.state.finalUserLocation)
              //  console.log('NOT IN IF==============>', gen.state.finalUserLocation, response.photos[i].shareSpotLocation.geohash)
              if (__WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].state.finalUserLocation != '' && __WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].state.finalUserLocation != undefined && response.photos[_i2].shareSpotLocation.geohash != "") {
                //  console.log('GOING IN IF :(')
                d1Lon = __WEBPACK_IMPORTED_MODULE_7_geo_hash___default.a.decode(__WEBPACK_IMPORTED_MODULE_5__gen__["a" /* default */].state.finalUserLocation);
                d1 = { latitude: d1Lon.lat, longitude: d1Lon.lon };
                d2Lon = __WEBPACK_IMPORTED_MODULE_7_geo_hash___default.a.decode(response.photos[_i2].shareSpotLocation.geohash);
                d2 = { latitude: d2Lon.lat, longitude: d2Lon.lon };
                distance = __WEBPACK_IMPORTED_MODULE_8_haversine___default()(d1, d2);
                isM = false;

                if (distance.toFixed(0) === '0') {
                  isM = true;
                  distance = __WEBPACK_IMPORTED_MODULE_8_haversine___default()(d1, d2, { unit: 'meter' });
                }
                state.filteredImagesArr[state.filteredImagesArr.length - 1].distance = distance.toFixed(0) + ' ' + (isM ? ' m' : ' km');
              } else {
                state.filteredImagesArr[state.filteredImagesArr.length - 1].distance = '-- km';
              }
              _context3.next = 32;
              break;

            case 31:
              return _context3.abrupt('break', 34);

            case 32:
              _context3.next = 23;
              break;

            case 34:
              _context3.next = 37;
              break;

            case 36:
              state.morePhotos = false;

            case 37:
              // console.log('state.filteredImagesArr', state.filteredImagesArr)
              state.maxPhotos = state.filteredImagesArr.length;
              // state.filteredImagesArr = x1.data

            case 38:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mutations: mutations,
  state: state,
  getters: getters
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(18);









var state = {
  nearBy: [],
  fetchingNearby: false,
  license: {}
};
var getters = {
  nearBy: function nearBy(state) {
    return state.nearBy;
  },
  fetchingNearby: function fetchingNearby(state) {
    return state.fetchingNearby;
  },
  lisense: function lisense(state) {
    return state.license;
  }
};
var mutations = {
  getNearbyPhotos: function getNearbyPhotos(state2, payload) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var payloadForAPI, x1, i;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (payload.startAt === 0) {
                state.nearBy = [];
              }
              payloadForAPI = payload;

              state.fetchingNearby = true;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["f" /* getNearbyPhotos */])(payloadForAPI));

            case 5:
              x1 = _context.sent;

              state.fetchingNearby = false;
              for (i in x1.data.nearbyPhotos) {
                state.nearBy.push(x1.data.nearbyPhotos[i]);
              }

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  goToImageDetMap: function goToImageDetMap(state2, payload) {
    __WEBPACK_IMPORTED_MODULE_5__common_common__["a" /* default */].state.imageDetParticular = payload.image;
    var caption = payload.caption;
    var id = payload.image.id === undefined ? payload.image.photoId : payload.image.id;
    var isLiked = payload.image.isLiked;
    if (!__WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].currentRoute.fullPath.includes('imageDetails')) {
      localStorage.setItem('path', __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].currentRoute.fullPath);
    }
    if (!isLiked) {
      window.thisOfApp.$modal.show('ask-to-add-to-wishlist');
      localStorage.removeItem('openDirections');
    } else if (isLiked) {
      localStorage.setItem('openDirections', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(true));
      __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push('/id/' + id + '?inapp=true');
    }
  }
};
var actions = {
  _top_image_section: function _top_image_section(state2, payload) {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(resolve) {
        var _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["g" /* _top_image_section */])(payload));

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                resolve(data);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  operationOnPhoto: function operationOnPhoto(state2, payload) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(resolve) {
        var _x3;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(payload.uid === __WEBPACK_IMPORTED_MODULE_7__auth_auth__["a" /* default */].state.user.uid)) {
                  _context3.next = 9;
                  break;
                }

                payload.isCron = false;

                if (!__WEBPACK_IMPORTED_MODULE_7__auth_auth__["a" /* default */].state.isLoggedIn) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__api__["h" /* operationOnPhoto */], {
                  params: payload
                });

              case 5:
                _x3 = _context3.sent;

                if (payload.operation === 'like' && _x3.data.status === 'added') {
                  if (JSON.parse(localStorage.getItem('firstLIke')) != true) {
                    localStorage.setItem('firstLIke', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(true));
                  }
                }

                if (payload.operation === 'checkin' && _x3.data.status === 'added') {
                  if (JSON.parse(localStorage.getItem('firstCheckin')) != true) {
                    localStorage.setItem('firstCheckin', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(true));
                  }
                }
                resolve(_x3.data.status);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
  },
  getImageDetails: function getImageDetails(state2, payload) {
    payload.isCron = false;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__api__["i" /* getParticularPhotoDetails */], {
        params: payload
      }).then(function (res) {
        state.license = res.data.license;
        state.license.photoSourceLink = res.data.photoSourceLink;
        var data = res.data;
        resolve(data);
      });
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

var state = {
	//
	filterLocation: "Anywhere",
	filterViewType: "Everything is better "
};

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__googleCloudVisionAPI__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_common_common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configurations__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configurations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__configurations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_dateTimeOrgIndex__ = __webpack_require__(215);




var ls = __webpack_require__(27);
var dms2dec = __webpack_require__(489);
var geo = __webpack_require__(53);






var state = {
  imageUploadingToStorage: false
};

var getters = {
  imageUploadingToStorage: function imageUploadingToStorage(state) {
    return state.imageUploadingToStorage;
  }
};

var mutations = {
  //
  uploadImage_1: function uploadImage_1(state) {
    // console.log(`upload, attach event listener...`)
    //
    document.getElementById("upload").addEventListener("click", function () {
      // console.log(`auth`, auth)
      var myUploadWidget = cloudinary.createUploadWidget({
        cloudName: __WEBPACK_IMPORTED_MODULE_6__configurations___default.a.cloudinary_cloudName,
        uploadPreset: "1920px",
        imageMetadata: true,
        theme: 'minimal',
        multiple: false,
        showPoweredBy: false,
        tags: ['UNLINKED PHOTO'],
        inlineContainer: "#inline_container",
        language: "en",
        styles: {
          palette: {
            window: "#ffffff",
            sourceBg: "#FFFFFF",
            windowBorder: "#FFFFFF",
            tabIcon: "#FFFFFF",
            inactiveTabIcon: "#FFFFFF",
            menuIcons: "#FFFFFF",
            link: "#56e3c2",
            action: "#56e3c2",
            inProgress: "#56e3c2",
            complete: "#339933",
            error: "#cc0000",
            textDark: "#ffffff",
            textLight: "#fcfffd"
          }
        },
        text: {
          "en": {
            "local": {
              "browse": "Select Image",
              "dd_title_single": "Drag and Drop an asset here",
              "dd_title_multi": "Drag and Drop assets here",
              "drop_title_single": "Drop a file to upload",
              "drop_title_multiple": "Drop files to upload"
            },
            "menu": {
              "files": "Upload a photo"
            }
          }
        },
        sources: ['local']
      }, function (error, result) {
        console.log("RESuLT", result);
        if (result.event === "success") {
          __WEBPACK_IMPORTED_MODULE_1__gen__["a" /* default */].state.opencw = false;
          document.getElementById('inline_container').innerHTML = '';
          //

          //save img link to db
          //
          // console.log(result[0])
          var picDetail = result.info;
          //
          var url = picDetail.url; //main pic url
          // console.log("[url] ", url)
          //
          var thumbnailImgUrl = picDetail.thumbnail_url;
          // console.log("[thumbnail image url]", thumbnailImgUrl)
          //
          var resourceType = picDetail.resource_type;
          // console.log("[resourceType] ", resourceType)
          //
          var publicId = picDetail.public_id;
          // console.log("[publicId]", publicId)
          //
          ls.set('thumbnailImgUrl', thumbnailImgUrl);
          //
          /******************* METADATA *******************/
          //
          var metaData = picDetail.image_metadata;
          // console.log("[metaData]", metaData)
          // try to get mon & dur
          var dateTimeOriginal = void 0;
          var _mon = void 0;
          var _mon2 = void 0;
          var _dur = void 0;
          var _dur2 = void 0;
          if (metaData.DateTimeOriginal != undefined) {
            dateTimeOriginal = metaData.DateTimeOriginal;
            // console.log({dateTimeOriginal})
            _mon = dateTimeOriginal[5] + dateTimeOriginal[6];
            // console.log({_mon})
            _mon2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helper_dateTimeOrgIndex__["a" /* _index_mon */])(_mon);
            // console.log({_mon2}) // 1st var
            _dur = parseInt(dateTimeOriginal[11] + dateTimeOriginal[12]);
            // console.log({_dur})
            _dur2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helper_dateTimeOrgIndex__["b" /* _index_dur */])(_dur);
            // console.log({_dur2}) // 2nd var
          } else {
            _mon2 = 'unknown';
            _dur2 = 'unknown';
          }

          // / try to get mon & dur ends
          var createdAt = void 0;
          var isOriginalDateNTime = false;
          //
          // *** TIMESTAMP ***
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(metaData).indexOf('DateTimeOriginal') != -1) {
            //if date exists in metadata
            isOriginalDateNTime = true;
            //
            // console.log("1", metaData.DateTimeOriginal)
            createdAt = metaData.DateTimeOriginal;
            //
            var createdAt_date = createdAt.substring(0, 10);
            // console.log("2", createdAt_date)
            var createdAt_time = createdAt.substring(11, 19);
            // console.log("3", createdAt_time)
            //
            createdAt_date = createdAt_date.split(':').join('-');
            // console.log("4", createdAt_date)
            //
            createdAt = ''; //empty
            createdAt = createdAt_date + 'T' + createdAt_time + 'Z'; //2017-12-21T18:14:58Z //format
            //
            // console.log("5", createdAt)
          } else {
            //date doesnot exists in metadata
            // console.log("created time", result.created_at)
            createdAt = "";
            // console.log("6", createdAt)
          }
          //
          createdAt = createdAt.substring(0, 16); //2017-12-21T18:14 //format
          //
          // *** TIMESTAMP ENDS ***
          //
          // *** LOCATION ***
          var geohash = '';
          var geoLocIsAvailable = false;
          //
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(metaData).indexOf('GPSLatitude') != -1 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(metaData).indexOf('GPSLongitude') != -1) {
            var geoLoc_lat = metaData.GPSLatitude;
            var geoLoc_lng = metaData.GPSLongitude;
            //
            // console.log("[geoLoc_lat]", geoLoc_lat)
            // console.log("[geoLoc_lng]", geoLoc_lng)
            //
            var degMinHr_lat_arr = geoLoc_lat.split(" "); //Hr => sec
            //
            var deg_lat = degMinHr_lat_arr[0];
            var min_lat = degMinHr_lat_arr[2];
            var hr_lat = degMinHr_lat_arr[3];
            var dir_lat = degMinHr_lat_arr[4];
            //
            min_lat = min_lat.replace("'", "");
            hr_lat = hr_lat.replace('"', "");
            //
            //
            var degMinHr_lng_arr = geoLoc_lng.split(" ");
            var deg_lng = degMinHr_lng_arr[0];
            var min_lng = degMinHr_lng_arr[2];
            var hr_lng = degMinHr_lng_arr[3];
            var dir_lng = degMinHr_lng_arr[4];
            //
            min_lng = min_lng.replace("'", "");
            hr_lng = hr_lng.replace('"', "");
            //
            // console.log("1 => " + deg_lat + " | " + min_lat + " | " + hr_lng + " | " + dir_lat)
            // console.log("2 ==> " + deg_lng + " | " + min_lng + " | " + hr_lat + " | " + dir_lng)
            //
            var parse_lat_para_1 = [];
            var parse_lat_para_2 = '';
            //
            var parse_lng_para_1 = [];
            var parse_lng_para_2 = '';
            //
            parse_lat_para_1.push(Number(deg_lat));
            parse_lat_para_1.push(Number(min_lat));
            parse_lat_para_1.push(Number(hr_lat));
            //
            parse_lat_para_2 = dir_lat;
            //
            // console.log("1 => ", parse_lat_para_1, parse_lat_para_2)
            //
            parse_lng_para_1.push(Number(deg_lng));
            parse_lng_para_1.push(Number(min_lng));
            parse_lng_para_1.push(Number(hr_lng));
            //
            parse_lng_para_2 = dir_lng;
            //
            // console.log("2 => ", parse_lng_para_1, parse_lng_para_2)
            //
            var dec = dms2dec(parse_lat_para_1, parse_lat_para_2, parse_lng_para_1, parse_lng_para_2);
            // console.log("[DEC]", dec)
            //
            geohash = geo.encode(dec[0], dec[1]);
            //
            geoLocIsAvailable = true;
            //
          } else {
              //do nothing
            }

          var photoSourceLink = "";
          // *** LOCATION ENDS ***
          //
          /****************  METADATA ENDS ****************/
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
            path: '/uploadImage_2',
            query: {
              url: url,
              resourceType: resourceType,
              publicId: publicId,
              //
              createdAt: createdAt,
              isOriginalDateNTime: isOriginalDateNTime,
              //
              geoLocIsAvailable: geoLocIsAvailable,
              geohash: geohash,
              _mon2: _mon2,
              _dur2: _dur2,
              photoSourceLink: photoSourceLink
            }
          });
          __WEBPACK_IMPORTED_MODULE_5__store_modules_common_common__["a" /* default */].state.isbottomMenuOpen = false;
          //Step 2.4:  Call the .close() method in order to close the widget
          myUploadWidget.close();
        }
      });
      if (__WEBPACK_IMPORTED_MODULE_4__store_modules_auth_auth__["a" /* default */].state.isLoggedIn) {
        // console.log(`Logged In: Opening Widget.`)
        __WEBPACK_IMPORTED_MODULE_1__gen__["a" /* default */].state.opencw = true;
        myUploadWidget.open();
      } else {
        console.log('User not logged in, redirecting to Login Page.');
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
          path: '/login'
        });
        __WEBPACK_IMPORTED_MODULE_5__store_modules_common_common__["a" /* default */].state.isbottomMenuOpen = false;
      }
    }, false);
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userDetails__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configurations__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configurations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__configurations__);







var state = {
  uploadProfilePhotoWidget: null
};

var getters = {};

var mutations = {
  //
  uploadNCrop_profilePic: function uploadNCrop_profilePic(state2) {
    this.uploadProfilePhotoWidget = cloudinary.createUploadWidget({
      cloudName: __WEBPACK_IMPORTED_MODULE_5__configurations___default.a.cloudinary_cloudName,
      uploadPreset: "1920px",
      imageMetadata: true,
      theme: 'minimal',
      multiple: false,
      showPoweredBy: false,
      sources: ['local']
    }, function (error, result) {
      //save img link to db
      if (result.event === "success") {
        var picDetail = result.info;
        var thumbnailUrl = picDetail.thumbnail_url;
        var picUrl = picDetail.url;
        //
        var user = __WEBPACK_IMPORTED_MODULE_3_firebase_app__["a" /* default */].auth().currentUser;
        //
        user.updateProfile({
          photoURL: thumbnailUrl
        }).then(function () {
          // console.log("[session][photoURL] // Update successful.")
          //
          __WEBPACK_IMPORTED_MODULE_2__userDetails__["a" /* default */].state.userDetails_photoURL = thumbnailUrl; //thumbnail
          //
          __WEBPACK_IMPORTED_MODULE_0__gen__["a" /* default */].actions.mergeDocToDb(state, {
            dbPath: 'users/' + __WEBPACK_IMPORTED_MODULE_1__auth_auth__["a" /* default */].state.user.uid,
            obj: {
              picUrl: picUrl
            }
          }).then(function () {
            //
            __WEBPACK_IMPORTED_MODULE_0__gen__["a" /* default */].mutations.snackbar_alert(state, {
              msg: 'Image Uploaded !'
            });
            //
            __WEBPACK_IMPORTED_MODULE_2__userDetails__["a" /* default */].state.userDetails_userDetails_profilePicUrl = picUrl;
            //
            window.thisOfVueComp.$forceUpdate();
            //
          });
          //
        }).catch(function (error) {
          console.log("[session][photoURL] // An error happened.");
        });
      }
      if (error) {
        console.log(error);
      }
    });
  },
  openCloudinaryWidget: function openCloudinaryWidget() {
    this.uploadProfilePhotoWidget.open();
  }
  //

};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_auth__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configurations__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configurations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__configurations__);












var state = {
  profile: {},
  maxProfileImg: -1,
  profileImages: [],
  totalCounts: {},
  selectedUploader: {},
  profileGeolocation: '',
  live_profile_pic: null, // uploaded
  hideMap: false,
  noCalls: false,
  cloudinaryWidgetOne: null
};
var getters = {
  profileGeolocation: function profileGeolocation(state) {
    return state.profileGeolocation;
  },
  profile: function profile(state) {
    return state.profile;
  },
  maxProfileImg: function maxProfileImg(state) {
    return state.maxProfileImg;
  },
  profileImages: function profileImages(state) {
    return state.profileImages;
  },
  totalCounts: function totalCounts(state) {
    return state.totalCounts;
  },
  selectedUploader: function selectedUploader(state) {
    return state.selectedUploader;
  },
  live_profile_pic: function live_profile_pic(state) {
    return state.live_profile_pic;
  },
  hideMap: function hideMap(state) {
    return state.hideMap;
  }
};
var mutations = {
  saveUploader: function saveUploader(state2, payload) {
    localStorage.setItem('uploader', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(payload));
  },
  getUserProfileDetails: function getUserProfileDetails(state2, payload) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var uid, x1;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              uid = payload.uid;
              // let uploader = payload.uploader

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api__["c" /* userProfileDetails */])({ uid: uid }));

            case 3:
              x1 = _context.sent;

              state.profile = x1.data;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  openCloudinaryProfileImageWidget: function openCloudinaryProfileImageWidget() {
    this.cloudinaryWidgetOne.open();
  },
  getProfileImages: function getProfileImages(state2, payload) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var uid, limit, startAt, tab, orderBy, userGeohash, isRandom, x1, i, photo, id, tmp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state.noCalls = false;
              state.hideMap = true;
              uid = payload.uid;
              limit = payload.limit;
              startAt = payload.startAt;
              tab = payload.tab;
              orderBy = payload.orderBy;
              userGeohash = __WEBPACK_IMPORTED_MODULE_9__gen__["a" /* default */].state.finalUserLocation;
              isRandom = payload.isRandom;
              _context2.next = 11;
              return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__api__["d" /* profileImages */], {
                params: {
                  profileUid: uid,
                  limit: limit,
                  startAt: startAt,
                  filter: tab,
                  viewerUid: __WEBPACK_IMPORTED_MODULE_6__modules_auth_auth__["a" /* default */].state.user.uid
                }
              });

            case 11:
              x1 = _context2.sent;

              //   if(!state.data){
              //     state.data  = await axios.get(profileImages, {
              //       params: {
              //         profileUid: uid,
              //         limit,
              //         startAt,
              //         filter: tab,
              //         viewerUid: auth.state.user.uid
              //       }
              //   })
              // }
              if (startAt === 0) {
                state.profileImages = [];
              }
              if (x1.data.hits.hits.length === 0) {
                state.noCalls = true;
              }

              for (i in x1.data.hits.hits) {
                photo = x1.data.hits.hits[i]._source;
                id = x1.data.hits.hits[i]._id;
                tmp = photo;

                tmp.id = id;
                state.profileImages.push(tmp);
              }

              // if(tab === "checkins"){
              //   for (let i in state.data.data.checkinData) {
              //     let photo = state.data.data.checkinData[i]._source
              //     let id = state.data.data.checkinData[i]._id
              //     let tmp = photo
              //     tmp.id = id
              //     state.profileImages.push(tmp)
              //   }
              // }
              // if(tab === "likes"){
              //   for (let i in state.data.data.likedDetails) {
              //     let photo = state.data.data.likedDetails[i]._source
              //     let id = state.data.data.likedDetails[i]._id
              //     let tmp = photo
              //     tmp.id = id
              //     state.profileImages.push(tmp)
              //   }
              // }
              // if(tab === "shared"){
              //   for (let i in state.data.data.submitted) {
              //     let photo = state.data.data.submitted[i]._source
              //     let id = state.data.data.submitted[i]._id
              //     let tmp = photo
              //     tmp.id = id
              //     state.profileImages.push(tmp)
              //   }
              // }
              state.hideMap = false;
              setTimeout(function () {
                if (document.getElementById('scroll-hor') !== null) {
                  var ele = document.getElementById('image-' + x1.data.hits.hits[0]._id).scrollIntoView();
                }
              }, 100);

              setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_9__gen__["a" /* default */].mutations.getLocationFinal();
              }, 10);

              state.maxProfileImg = x1.data.totalPhotos;
              if (x1.data.totalCounts != undefined) {
                // state.maxProfileImg = state.profileImages.length
                // if (state.data.data.totalCounts != undefined) {
                state.totalCounts = x1.data.totalCounts;
              }

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};
var actions = {
  saveProfileChanges: function saveProfileChanges(state2, payload) {
    /* return new Promise((resolve) => {
      let x1 = await axios.get(editBasicProfileDetails, {
        params: payload
      })
      resolve()
    })*/
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resolve) {
        var x1;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__api__["e" /* editBasicProfileDetails */], {
                  params: payload
                });

              case 2:
                x1 = _context3.sent;
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7_firebase_app__["a" /* default */].auth().currentUser.updateProfile({
                  photoURL: payload.dp
                });

              case 5:
                __WEBPACK_IMPORTED_MODULE_6__modules_auth_auth__["a" /* default */].state.user = __WEBPACK_IMPORTED_MODULE_7_firebase_app__["a" /* default */].auth().currentUser;
                resolve('done');

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  getProfileImageLink: function getProfileImageLink(state2) {
    this.cloudinaryWidgetOne = cloudinary.createUploadWidget({
      cloudName: __WEBPACK_IMPORTED_MODULE_10__configurations___default.a.cloudinary_cloudName,
      uploadPreset: "1920px",
      multiple: false,
      show_powered_by: false,
      imageMetadata: true,
      theme: 'minimal',
      sources: ['local']
    }, function (error, result) {

      if (!error && result && result.event === "success") {
        state.live_profile_pic = result.info.url;
      }
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = {
    // cloudinary developement
    // cloudinary_cloudName: 'dayeblttk',
    // cloudinary_apiKey: '616728461466718',
    // cloudinary_apiSecret: 'RYMOwH4OAk0e7AEAh12xxMysweM',
    // cloudinary_preset: 'v1596539510',
    // cloudinary_settings: 'f_auto,fl_lossy,q_auto,dpr_auto,e_improve',

    // cloudinary production
    cloudinary_cloudName: 'xviewzzzx',
    cloudinary_apiKey: '194857481468858',
    cloudinary_apiSecret: 'LkdKocQmShIEArwY3VGlfMU2VZE',
    cloudinary_preset: 'v1540590871',
    cloudinary_settings: 'f_auto,fl_lossy,q_auto,dpr_auto,e_improve',

    currentDomain: window.location.origin
};

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dbRefs__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_geo_hash__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_geo_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_geo_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_common__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_querystring__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_querystring__);







//var XMLHttpRequest = require("xmlhttprequest").XMLHttpRequest;
//var xhr = new XMLHttpRequest();


var state = {
  isAPICalling: false,
  btnLoader: false,
  snackbar_alert_msg: '',
  appName: '',
  loader: false,
  forceRouteLoader: true,
  showSnack: false,
  _isFirstVisit: false,
  showLoader: false,
  finalUserLocation: '',
  sheet: false,
  opencw: false,
  share_photoId: '',
  share_caption: ''
};

var getters = {
  btnLoader: function btnLoader(state) {
    return state.btnLoader;
  },
  snackbar_alert_msg: function snackbar_alert_msg(state) {
    return state.snackbar_alert_msg;
  },
  appName: function appName(state) {
    return state.appName;
  },
  loader: function loader(state) {
    return state.loader;
  },
  forceRouteLoader: function forceRouteLoader(state) {
    return state.forceRouteLoader;
  },
  _isFirstVisit: function _isFirstVisit(state) {
    return state._isFirstVisit;
  },
  finalUserLocation: function finalUserLocation(state) {
    return state.finalUserLocation;
  },
  sheet: function sheet(state) {
    return state.sheet;
  },
  opencw: function opencw(state) {
    return state.opencw;
  }
};

var mutations = {
  //
  UPDATE_IS_API_CALLING: function UPDATE_IS_API_CALLING(state2, payload) {
    var val = payload.val;
    state.isAPICalling = val;
  },
  getLocationFinal: function getLocationFinal(state2) {
    // console.log('localStorage.getItem(isLocationEnabled)', localStorage.getItem('isLocationEnabled'))
    if (localStorage.getItem('isLocationEnabled') != null) {
      // console.log('CALLING GET LOCATION')
      if (navigator.geolocation) {
        __WEBPACK_IMPORTED_MODULE_6__common_common__["a" /* default */].state.fetchLocLoader = true;
        navigator.geolocation.getCurrentPosition(function (success) {
          __WEBPACK_IMPORTED_MODULE_6__common_common__["a" /* default */].state.fetchLocLoader = false;
          // console.log('CALLING GET LOCATION 2')
          localStorage.setItem('isLocationEnabled', 'y'); // allow
          state.finalUserLocation = __WEBPACK_IMPORTED_MODULE_5_geo_hash___default.a.encode(success.coords.latitude, success.coords.longitude);
          // console.log('state.finalUserLocation', state.finalUserLocation)
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_6__common_common__["a" /* default */].state.fetchLocLoader = false;
          // console.log('JSON.parse(localStorage.getItem(isLocationEnabled)',localStorage.getItem('isLocationEnabled'))
          if (localStorage.getItem('isLocationEnabled') != null) {
            __WEBPACK_IMPORTED_MODULE_6__common_common__["a" /* default */].state.showOverlay = true;
          }

          // let cnt = JSON.parse(localStorage.getItem('locationBlockCnt'))
          /*  if(cnt === null) {
              cnt = 1
            }
            else {
              common.state.showOverlay = true
              cnt += 1
            } */
          localStorage.removeItem('isLocationEnabled');
          // localStorage.setItem('locationBlockCnt', JSON.stringify(cnt))
          // block or close popup
        });
        window.thisOfApp.$modal.hide('location-modal');
      }
    }
  },
  checkIfLocAllowed: function checkIfLocAllowed(state2) {
    // console.log('calling checkIfLocAllowed')
    var isLocAllowed = localStorage.getItem('isLocationEnabled');
    if (isLocAllowed == 'y') {
      mutations.getLocationFinal(state);
    }
  },

  //
  //goTo
  goTo: function goTo(state2, path) {
    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push(path);
  },

  //
  //snackbar //alert
  snackbar_alert: function snackbar_alert(state2, payload) {
    //
    state.snackbar_alert_msg = payload.msg;
    //
    // var x = document.getElementById("snackbar")
    // x.className = "show"
    // setTimeout(function(){
    // x.className = x.className.replace("show", "")
    // }, 3000)
    state.showSnack = true;
  },

  //
  //forceRoute
  forceRoute: function forceRoute(state2, payload) {
    console.log('forceRoute', payload);
    //
    //state.forceRouteLoader = true
    //
    if (payload.routeName == 'User Details' || payload.routeName.indexOf('Upload Image') != -1) {
      if (!__WEBPACK_IMPORTED_MODULE_2__auth_auth__["a" /* default */].state.isLoggedIn) {
        //go back
        mutations.goTo(state, '/');
      }
    }
    //
    setTimeout(function () {
      state.forceRouteLoader = false;
    }, 100);
  }
};

var actions = {
  //
  isEmptyField: function isEmptyField(state2, payload) {
    //accepts arr of object( *fieldValue* to validate & *fieldName* (to notify err)), check if strings are empty
    // console.log("[isEmptyPayload]", payload)
    //
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (res) {
      //
      var isEmpty = false;
      var fieldName = void 0;
      //
      for (var i in payload.checkVarsIfEmpty_arr) {
        // console.log("isEmptyField => ", payload.checkVarsIfEmpty_arr[i])
        if (payload.checkVarsIfEmpty_arr[i].fieldValue.length == 0) {
          //use regex instead
          fieldName = payload.checkVarsIfEmpty_arr[i].fieldName;
          isEmpty = true;
          break;
        }
      }
      //
      if (isEmpty) {
        //prints message if empty
        mutations.snackbar_alert(state, {
          msg: 'Empty Field: ' + fieldName
        });
      }
      //
      res(isEmpty); // returns true if empty, or returns false
    });
  },

  //
  //save doc in db
  mergeDocToDb: function mergeDocToDb(state2, payload) {
    // console.log("[saveDocToDb] => ", payload)
    //
    var dbPath = payload.dbPath;
    var obj = payload.obj;
    //
    return __WEBPACK_IMPORTED_MODULE_3__dbRefs__["a" /* default */].state.firestore.doc(dbPath).set(obj);
  },

  //
  //get data from => doc
  getDataFromDoc: function getDataFromDoc(state2, payload) {
    // console.log("[get data form doc]", payload)
    //
    var dbPath = payload.dbPath;
    //
    return __WEBPACK_IMPORTED_MODULE_3__dbRefs__["a" /* default */].state.firestore.doc(dbPath).get();
    //
  },

  //
  //axios get request
  axiosGetReq: function axiosGetReq(state2, payload) {
    //payload => url, obj
    // console.log("[axios get request]" , payload)
    //
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(payload.url, {
      params: payload.obj
    });
  },

  //
  //axios post request
  axiosPostReq: function axiosPostReq(state2, payload) {
    // console.log("[axios post request]" , payload)
    //
    // console.log("[axiosPostUrl]", payload.url)
    // console.log("[axiosGetUrl]", payload.obj)
    //
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(payload.url, payload.obj);
  },

  //
  //get past tags selected by the users
  getTags_uploadImage: function getTags_uploadImage(state2, payload) {
    var qStr = payload.qStr;
    var qTag = payload.qTag;
    //
    // console.log("[qStr]", qStr)
    // console.log("[qTag]", qTag)
    //
    return actions.axiosGetReq(state, {
      url: 'https://us-central1-travel-app-admin.cloudfunctions.net/getTagSuggestion_uploadImage',
      obj: {
        qStr: qStr,
        qTag: qTag,
        isCron: 'n'
      }
    });
  },

  //
  //save image in - storage
  saveImgInStorage: function saveImgInStorage(state2, payload) {
    //
    // console.log("[uploadImageStorage]", payload)
    //
    var pKey = payload.pUrl.slice(payload.pUrl.lastIndexOf('/') + 1);
    var pBlob = payload.pBlob;
    //
    //console.log("2 => ",state.storage)
    //
    //console.log(payload)
    //console.log(pKey)
    //console.log(payload.pBlob)
    //
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (res, err) {
      //
      var uploadTask = __WEBPACK_IMPORTED_MODULE_3__dbRefs__["a" /* default */].state.storage.ref(pKey).put(pBlob);
      //
      uploadTask.on('state_changed', function (snapshot) {
        //
        //
      }, function (error) {
        //
        //console.log(error)
        err(error);
        //
      }, function () {
        //
        //console.log(uploadTask.snapshot.downloadURL)
        res({
          pKey: pKey,
          downloadUrl: uploadTask.snapshot.downloadURL
        });
        //
      });
    });
  },

  //
  //upload image - DOM
  uploadImg: function uploadImg(state2, payload) {
    //DOM
    //
    var pUrl = URL.createObjectURL(payload.event.target.files[0]); //
    var pKey = pUrl.slice(pUrl.lastIndexOf('/') + 1); //
    //
    var pBlob = payload.event.target.files[0];
    //
    state.pObj = {};
    //
    //if(!payload.mulImg){ // if not multiple image clear obj
    //state.pObj = {}
    //}
    //
    state.pObj = {
      pBlob: pBlob,
      pUrl: pUrl
      //
      //console.log(state.pObj)
      //
      //window.tag.$forceUpdate() //no need not showing pic
    };
  },

  //
  arrayUnique: function arrayUnique(array) {
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_gen__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gen__ = __webpack_require__(4);





var state = {
  isbottomMenuOpen: false,
  isModeSwipe: false,
  showOverlay: false,
  fetchLocLoader: false,
  toggleForAddToWishlist: false,
  imageDetParticular: {},
  swichModesBG: false
};
var getters = {
  swichModesBG: function swichModesBG(state) {
    return state.swichModesBG;
  },
  imageDetParticular: function imageDetParticular(state) {
    return state.imageDetParticular;
  },
  toggleForAddToWishlist: function toggleForAddToWishlist(state) {
    return state.toggleForAddToWishlist;
  },
  fetchLocLoader: function fetchLocLoader(state) {
    return state.fetchLocLoader;
  },
  showOverlay: function showOverlay(state) {
    return state.showOverlay;
  },
  isbottomMenuOpen: function isbottomMenuOpen(state) {
    return state.isbottomMenuOpen;
  },
  isModeSwipe: function isModeSwipe(state) {
    return state.isModeSwipe;
  }
};
var mutations = {
  addToWishlish: function addToWishlish() {
    if (__WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* default */].state.isLoggedIn) {

      console.log('state.imageDetParticular=>', state.imageDetParticular);
      var caption = state.imageDetParticular.caption === '' ? 'n' : state.imageDetParticular.caption;
      var id = state.imageDetParticular.id === undefined ? state.imageDetParticular.photoId : state.imageDetParticular.id;
      localStorage.setItem('openDirections', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(true));
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/id/' + id + '?inapp=true');
      setTimeout(function () {
        state.toggleForAddToWishlist = !state.toggleForAddToWishlist;
      }, 50);
    } else {
      __WEBPACK_IMPORTED_MODULE_4__gen__["a" /* default */].mutations.snackbar_alert(state, { msg: 'Please sign in to complete your desired action' });
      window.thisOfApp.$modal.hide('ask-to-add-to-wishlist');
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
    }
  },
  fadeOpen: function fadeOpen(state2) {
    console.log(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_gen__["a" /* ele */])('bottom-menu'));
    if (state.isbottomMenuOpen) {
      setTimeout(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_gen__["a" /* ele */])('bottom-menu').style.opacity = 1;
      }, 300);
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ARROW.d031d84.png";

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(525),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e89246c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(529),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(526),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-721f8d9b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(530),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(527),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-687762b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e3e32322",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 522:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  })
},staticRenderFns: []}

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom",
    attrs: {
      "id": "model"
    }
  }, [_c('div', {
    staticClass: "main-container",
    on: {
      "click": function($event) {
        _vm.$store.state.common.isbottomMenuOpen = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "12.315270935960589vh",
      "right": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "6px",
      "padding-bottom": "26px"
    }
  }, [_c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.share()
      }
    }
  }, [(_vm.os === 'iOS' || _vm.desktop === 'mac') ? _c('img', {
    staticStyle: {
      "height": "16px"
    },
    attrs: {
      "src": "https://png.icons8.com/ios/96/2d35cd/upload.png"
    }
  }) : _c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n                share\n              ")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/settings')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("settings")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile('Person')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile('Check-ins')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("location_on")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile('Wishlist')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("favorite")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": _vm.goToUpload
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#2d35cd"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add_a_photo")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-right": "26px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.screenW < 600) ? _c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToHome(true)
      }
    }
  }, [_c('v-icon', {
    style: (("color: " + (_vm.selectedMode === 'Fullscreen' ? '#febd35' : '#2d35cd'))),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("zoom_out_map")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToHome(null)
      }
    }
  }, [_c('v-icon', {
    style: (("color: " + (_vm.selectedMode === 'Map' ? '#febd35' : '#2d35cd'))),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "top-btn",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goToHome(false)
      }
    }
  }, [_c('v-icon', {
    style: (("color: " + (_vm.selectedMode === 'List' ? '#febd35' : '#2d35cd'))),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("view_day")])], 1)], 1)]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "top-btn",
    staticStyle: {
      "background": "#2d35cd",
      "height": "60px",
      "width": "60px",
      "margin-right": "15px"
    },
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("clear")])], 1)], 1)])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.maintainer) ? _c('div', [_c('div', [(_vm.$store.state.gen.showLoader) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "align-items": "center",
      "justify-content": "center",
      "width": "100vw",
      "z-index": "1000",
      "height": "100vh",
      "position": "fixed",
      "background-color": "#000000"
    },
    attrs: {
      "onload": this.getQuotes()
    }
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loader-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader/loading-viewZzz.svg",
      "height": "30"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-quote"
  }, [_c('p', {
    staticClass: "quoteText"
  }, [_vm._v(_vm._s(_vm.currentQuote.text))]), _vm._v(" "), _c('p', {
    staticClass: "quoteAuthor"
  }, [_vm._v(_vm._s(_vm.currentQuote.author))])])])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "clickToClose": false,
      "pivotY": 0.65,
      "width": "309",
      "height": "auto",
      "name": "praise-mode-modal"
    }
  }, [_c('div', {
    staticClass: "modal-main-container-praise"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("blur_circular")])]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  }, [_c('div', {
    staticClass: "div-2A"
  }, [_vm._v("Welcome to the distraction")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A"
  }, [_vm._v("free praise mode.")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A"
  }, [_vm._v("No text & icons.")])]), _vm._v(" "), _c('div', {
    staticClass: "div-3"
  }, [_c('div', {
    staticClass: "div-A"
  }, [_vm._v("How to exit the praise mode?")]), _vm._v(" "), _c('div', {
    staticClass: "div-B"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("1. Tap anywhere")])])]), _vm._v(" "), _c('div', {
    staticClass: "div-4"
  }, [_c('div', {
    staticClass: "div-4A pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('praise-mode-modal')
      }
    }
  }, [_c('div', {
    staticClass: "div-4AA"
  }, [_vm._v("GOT IT!")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-main-container-loc-parent"
  }, [_c('modal', {
    staticStyle: {
      "z-index": "900000000"
    },
    attrs: {
      "clickToClose": false,
      "width": "309",
      "height": "auto",
      "name": "ask-to-add-to-wishlist"
    }
  }, [_c('div', {
    staticClass: "modal-main-container-loc"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_c('div', {
    staticClass: "div-e1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  }, [_c('div', {
    staticClass: "div-2A"
  }, [_vm._v("To find out exact location or")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A"
  }, [_vm._v("driving directions of a view, it")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A"
  }, [_vm._v("should be on your travel list.")])]), _vm._v(" "), _c('div', {
    staticClass: "div-3"
  }, [_c('div', {
    staticClass: "div-3A"
  }, [_c('div', {
    staticClass: "div-3AA pointer",
    on: {
      "click": function($event) {
        return _vm.addToWishlish()
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Add to travel list")]), _vm._v(" "), _c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "div-4"
  }, [_c('div', {
    staticClass: "div-4A pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ask-to-add-to-wishlist')
      }
    }
  }, [_c('div', {
    staticClass: "div-4AA"
  }, [_vm._v("GOT IT!")])])])])])], 1), _vm._v(" "), _c('modal', {
    staticStyle: {
      "z-index": "900000000"
    },
    attrs: {
      "pivotY": 0.65,
      "width": "309",
      "height": "auto",
      "name": "license-modal"
    }
  }, [_c('div', {
    staticClass: "modal-main-container"
  }, [(_vm.$store.state.imageDetails.license !== undefined) ? _c('div', {
    staticClass: "div-2"
  }, [_c('div', {
    staticClass: "div-2A text-xs-left"
  }, [_vm._v("Copyright Information")]), _vm._v(" "), _c('div', {
    staticClass: "div-2A light-blue--text"
  }, [_c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.$store.state.imageDetails.license.licenseLink)
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.imageDetails.license.type))]), _vm._v("\n                /\n                "), _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.openInTab(_vm.$store.state.imageDetails.license.photoSourceLink)
      }
    }
  }, [_vm._v("Photo")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "div-4"
  }, [_c('div', {
    staticClass: "div-4A pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('likes-modal')
      }
    }
  }, [_c('div', {
    staticClass: "div-4AA"
  }, [_c('div', {
    staticClass: "div-3",
    staticStyle: {
      "margin-top": "unset"
    }
  }, [_c('div', {
    staticClass: "div-3AA",
    staticStyle: {
      "font-size": "0.813em"
    }
  }, [_vm._v("\n                      Report any copyright violations to contact@withaview.co\n                    ")])])])])])])]), _vm._v(" "), _c('modal', {
    staticStyle: {
      "z-index": "900000000"
    },
    attrs: {
      "clickToClose": false,
      "pivotY": 0.82,
      "width": "309",
      "height": "158",
      "name": "location-modal"
    }
  }, [_c('div', {
    staticClass: "praise-mode-modal"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "text-loc",
    staticStyle: {
      "letter-spacing": "0.13em"
    }
  }, [_vm._v("\n                Do you want to know how far is this view from you?\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "no",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('location-modal')
      }
    }
  }, [_vm._v("NO")]), _vm._v(" "), _c('div', {
    staticClass: "yes",
    on: {
      "click": function($event) {
        _vm.saveLocAllowedInLs();
        _vm.getLocationFinal();
      }
    }
  }, [_vm._v("\n                  YES\n                ")])])])])]), _vm._v(" "), (_vm.showOverlay) ? _c('div', {
    style: (("display: " + (_vm.showOverlay === true ? 'block' : 'none'))),
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": function($event) {
        _vm.$store.state.common.showOverlay = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "2px",
      "top": "10px",
      "height": "100px"
    },
    attrs: {
      "src": __webpack_require__(512)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#ffffff",
      "font-weight": "400",
      "font-family": "Avenir, Helvetica, Arial, sans-serif",
      "position": "absolute",
      "top": "90px",
      "right": "110px",
      "font-size": "14px",
      "left": "10px"
    }
  }, [_vm._v("\n              Location has been blocked from the browser, To turn on location,\n              go to → Settings → Site settings/Content settings\n              → Location → Blocked →\n              https://www.withaview.co → Permissions → Location\n              access: Allow/Delete\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.dbRefLoader || _vm.authLoader) ? _c('div') : _c('div', [_c('main', {
    class: ("bottom-menu-class-" + (_vm.$store.state.common.isbottomMenuOpen))
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    },
    on: {
      "after-enter": function($event) {}
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), (_vm.isbottomMenuOpen) ? _c('div', {
    staticClass: "bottom-menu",
    attrs: {
      "id": "bottom-menu"
    }
  }, [_c('bottom-menu')], 1) : _vm._e(), _vm._v(" "), _c('snackbar_alert'), _vm._v(" "), _c('v-bottom-sheet', {
    staticStyle: {
      "z-index": "2000"
    },
    model: {
      value: (_vm.$store.state.gen.sheet),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.gen, "sheet", $$v)
      },
      expression: "$store.state.gen.sheet"
    }
  }, [_c('v-list', [_c('v-subheader', [_vm._v("Share via")]), _vm._v(" "), _vm._l((_vm.tiles), function(tile) {
    return _c('v-list-tile', {
      key: tile.title,
      on: {
        "click": function($event) {
          _vm.$store.state.gen.sheet = false;
          tile.func();
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-avatar', {
      attrs: {
        "size": "32px",
        "tile": ""
      }
    }, [_c('v-lazy-image', {
      attrs: {
        "src": tile.img,
        "alt": tile.title
      }
    })], 1)], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(tile.title))])], 1)
  })], 2)], 1)], 1)]) : _c('maintainer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    model: {
      value: (_vm.$store.state.gen.showSnack),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.gen, "showSnack", $$v)
      },
      expression: "$store.state.gen.showSnack"
    }
  }, [_c('div', [_c('div', [_vm._v("\n        " + _vm._s(_vm.line1) + "\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(_vm.line2) + "\n      ")])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "pink",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.$store.state.gen.showSnack = false
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "white"
    }
  }, [_c('h1', [_vm._v("Signing in with Google...m")])])
}]}

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('div', {
    attrs: {
      "id": "maincontainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftcolumn"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/')
      }
    }
  }, [_vm._v(_vm._s(_vm.appName))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contentwrapper"
    }
  }, [_c('span', {
    staticClass: "user-display-name"
  }, [(_vm.isLoggedIn) ? _c('span', [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goTo('/UserDetails')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _c('span', [_vm._v(" | ")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])]) : _c('span', [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goTo('/Login')
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('span', [_vm._v(" | ")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.goTo('/Signup')
      }
    }
  }, [_vm._v("Signup")])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/wav-logo.png",
      "alt": "logo",
      "height": "30px"
    }
  }), _vm._v(" "), (_vm.isSignedIn) ? _c('div', {
    staticClass: "message"
  }, [_c('h2', {
    staticClass: "success"
  }, [_vm._v("Successfully Logged In!")]), _vm._v(" "), _c('p', [_vm._v("Welcome back! You are now signed in.")])]) : _c('div', {
    staticClass: "message"
  }, [_c('h2', {
    staticClass: "error"
  }, [_vm._v("Login link has been expired")]), _vm._v(" "), _c('p', [_vm._v("Please check your login credentials or try signing in again.")])]), _vm._v(" "), (!_vm.isSignedIn) ? _c('a', {
    staticClass: "button",
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("\n      Sign In\n    ")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "white"
    }
  }, [_c('h1', [_vm._v("Signing in with Facebook...")])])
}]}

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("\n    Your email is not verified !\n    "), _c('span', {
    staticClass: "click-here",
    on: {
      "click": _vm.resendEmailVerficationLink
    }
  }, [_vm._v("\n      Click here\n    ")]), _vm._v("\n    to resend verification link to your registered email address ! ")])])
},staticRenderFns: []}

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "sub-container"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "top-container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('div', {
    staticClass: "viewzzz-container"
  }, [_c('div', {
    staticClass: "view"
  }, [_vm._v("view"), _c('span', {
    staticClass: "viewzzz-main-z"
  }, [_vm._v("Z")]), _vm._v("zz")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "middle-container"
  }, [_c('div', {
    staticClass: "messages"
  }, [_c('div', {
    staticClass: "message-container"
  }, [_c('div', {
    staticClass: "imp-message"
  }, [_c('div', {
    staticClass: "text-head"
  }, [_vm._v("\n                  Sorry this site is undergoing some Changes\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "text-sub-head"
  }, [_vm._v("\n                  Please check with us again soon!\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "bottom-container"
  })]), _vm._v(" "), _c('div', {
    staticClass: "social-main-container"
  }, [_c('div', {
    staticClass: "bottom-sub-container"
  })])])])])
}]}

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  dbRefLoader: true,
  firestore: {},
  storage: {}
};

var getters = {
  dbRefLoader: function dbRefLoader(state) {
    return state.dbRefLoader;
  }
};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var ls = __webpack_require__(27);


var state = {
  spotType_uploadImage: [],
  selectedSpotType_uploadImage: [],
  //
  anyoneCanVisitThisSpot_uploadImage: true
};

var getters = {};

var mutations = {
  //
  goTo_uploadImage_5: function goTo_uploadImage_5(state2, payload) {
    // console.log("[uploadImage_4]", payload)
    //
    //validate array if not empty
    //if(payload.spotType.length != 0){
    //proceed
    //
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
      path: '/uploadImage_5',
      query: {
        url: payload.url,
        resourceType: payload.resourceType,
        publicId: payload.publicId,
        //
        createdAt: payload.createdAt,
        //
        caption: payload.caption,
        emotionalAppeal: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload.emotionalAppeal),
        //
        shareSpotLocation: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload.shareSpotLocation),
        hasGeohash: payload.hasGeohash,
        //
        spotType: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload.spotType),
        anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot
      }
    });
    //} else { // error
    //gen.mutations.snackbar_alert(state, {
    //msg: 'Please select at least one tag in spot type related to the image'
    //})
    //}
    //
  },

  //
  // get google map api
  getSpotTypeSuggestions_fromLocalStorage: function getSpotTypeSuggestions_fromLocalStorage(state2) {
    var gotSpotTypeSuggestionsFromLocalStorgae = JSON.parse(ls.get('spotTypeSuggestions'));
    if (gotSpotTypeSuggestionsFromLocalStorgae != null) {
      state.spotType_uploadImage = gotSpotTypeSuggestionsFromLocalStorgae;
    }
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_configurations__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_configurations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__functions_configurations__);


/* harmony default export */ __webpack_exports__["a"] = ({
  // apiKey: "AIzaSyCDm0m7yKThLUaBvYwM2sGCb-7zsX2n79I",
  // authDomain: "beautiful-planet.firebaseapp.com",
  // databaseURL: "https://beautiful-planet.firebaseio.com",
  // projectId: "beautiful-planet",
  // storageBucket: "beautiful-planet.appspot.com",
  // messagingSenderId: "948719280954"
  apiKey: __WEBPACK_IMPORTED_MODULE_0__functions_configurations___default.a.apiKey,
  authDomain: __WEBPACK_IMPORTED_MODULE_0__functions_configurations___default.a.authDomain,
  databaseURL: __WEBPACK_IMPORTED_MODULE_0__functions_configurations___default.a.databaseURL,
  projectId: __WEBPACK_IMPORTED_MODULE_0__functions_configurations___default.a.projectId,
  storageBucket: __WEBPACK_IMPORTED_MODULE_0__functions_configurations___default.a.storageBucket,
  messagingSenderId: __WEBPACK_IMPORTED_MODULE_0__functions_configurations___default.a.messagingSenderId,
  appId: __WEBPACK_IMPORTED_MODULE_0__functions_configurations___default.a.appId,
  measurementId: __WEBPACK_IMPORTED_MODULE_0__functions_configurations___default.a.measurementId
});

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gen__ = __webpack_require__(4);


var ls = __webpack_require__(27);
//
var state = {
  googleCloudVisionAPI_landmarkSuggestion: [],
  googleCloudVisionAPI_labelSuggestion: []
};

var getters = {
  googleCloudVisionAPI_landmarkSuggestion: function googleCloudVisionAPI_landmarkSuggestion(state) {
    return state.googleCloudVisionAPI_landmarkSuggestion;
  },
  googleCloudVisionAPI_labelSuggestion: function googleCloudVisionAPI_labelSuggestion(state) {
    return state.googleCloudVisionAPI_labelSuggestion;
  }
};

var mutations = {
  //
  googleCloudVisionAPI_labelNLandmarkSuggestion_byImgUrl: function googleCloudVisionAPI_labelNLandmarkSuggestion_byImgUrl(state2, payload) {
    //
    var imageUrl = payload.imageUrl;
    //
    __WEBPACK_IMPORTED_MODULE_1__gen__["a" /* default */].actions.axiosPostReq(state, {
      url: 'https://vision.googleapis.com/v1/images:annotate?key=AIzaSyDp9pMMMo8Yiy13OwDbZnO2BY_1qwQSEn0',
      obj: { // request
        "requests": [{
          "image": {
            "source": {
              "imageUri": imageUrl
            }
          },
          "features": [{
            "type": "LANDMARK_DETECTION"
          }, {
            "type": "LABEL_DETECTION"
          }]
        }]
      }
    }).then(function (response) {
      //
      var result = response.data.responses[0];
      // console.log("#########[GOOGLE VISION API]#########", result)
      //
      var googleAPISuggestion_labels = result.labelAnnotations;
      // console.log("1", googleAPISuggestion_labels)
      //
      var googleAPISuggestion_landmarks = result.landmarkAnnotations;
      // console.log("2", googleAPISuggestion_landmarks)
      //
      //
      // console.log("label => " + googleAPISuggestion_labels + " | " + undefined)
      if (googleAPISuggestion_labels != undefined) {
        //
        var labelArr = [];
        for (var i in googleAPISuggestion_labels) {
          // console.log(googleAPISuggestion_labels[i].description)
          labelArr.push(googleAPISuggestion_labels[i].description);
        }
        //
        ls.set('googleVisionAPI_labelSuggestion', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(labelArr));
        setTimeout(function () {
          console.log("[G]", JSON.parse(ls.get('googleVisionAPI_labelSuggestion')));
        }, 1000);
      }
      //
      // console.log("landmarks => " + googleAPISuggestion_landmarks + " | " + undefined)
      if (googleAPISuggestion_landmarks != undefined) {
        //
        var landmarkArr = [];
        for (var _i in googleAPISuggestion_landmarks) {
          // console.log(googleAPISuggestion_landmarks[i].description)
          landmarkArr.push(googleAPISuggestion_landmarks[_i].description);
        }
        //
        ls.set('googleVisionAPI_landmarkSuggestion', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(landmarkArr));
        // setTimeout(()=>{
        //   console.log("[G]", JSON.parse(ls.get('googleVisionAPI_landmarkSuggestion')))
        // },1000)
      }
    });
  },

  //
  setEmptyVar_ls: function setEmptyVar_ls(state2) {
    //
    ls.set('googleVisionAPI_landmarkSuggestion', //saving response in local storage => landmark
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]));
    //
    ls.set('googleVisionAPI_labelSuggestion', //saving response in local storage => label
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]));
    //
    ls.set('imaggaSuggestions', //saving response in local storage => imagga, label
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([]));
  }
};

var actions = {
  //
  //
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uploadImage_4__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__uploadImage_5__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);





//




//
var ls = __webpack_require__(27);

var state = {
  createdAt: '',
  //
  selectedLocationVisible_uploadImage: [], //earlier it was in this page
  locationVisible_uploadImage: [],
  //
  caption_uploadImage: ' ',
  //
  emotionalAppeal_uploadImage: [],
  selectedemotionalAppeal_uploadImage: [],
  //
  qStr_tags_uploadImage: null, // emotional appeal
  qStr_tags2_uploadImage: null, // spot type
  //
  qStr_searchThisTag: '',
  //
  qStr_thisTagWasSearchedLast: '', // emotional appeal
  qStr_thisTagWasSearchedLast2: '', // spot type
  //
  openMapDialog: false
};

var getters = {
  selectedLocationVisible_uploadImage: function selectedLocationVisible_uploadImage(state) {
    return state.selectedLocationVisible_uploadImage;
  },
  openMapDialog: function openMapDialog(state) {
    return state.openMapDialog;
  }
};

var mutations = {
  //
  /* goTo_uploadImage_3(state2, payload){
    console.log("[go to uploadImage_3]", payload)
    //
    //validate fields
    //
    let checkVarsIfEmpty_arr = [] //arr of obj, obj -> fieldName, fieldValue
    /*checkVarsIfEmpty_arr.push({
      fieldName: 'Caption',
      fieldValue: payload.caption
    })*/
  //
  /*gen
    .actions
    .isEmptyField(state2, {
      checkVarsIfEmpty_arr
    })
    .then((isEmpty)=>{
    console.log("[upload_2][filed empty]", isEmpty)
      if(!isEmpty){
        //
        //if(payload.emotionalAppeal.length != 0){ // validate tag arr, check arr len
          console.log("[//go to next page]")
          //
          let url = payload.url
          let resourceType = payload.resourceType
          let publicId = payload.publicId
          //
          let geohash = payload.geohash
          let geoLocIsAvailable = payload.geoLocIsAvailable
          //
          let caption = payload.caption
          let emotionalAppeal = payload.emotionalAppeal
          let spotType = payload.spotType
          let anyoneCanVisitThisSpot = payload.anyoneCanVisitThisSpot
          //
          let createdAt = payload.createdAt
          //
          //route to upload page 3
          router.push({
            path: '/uploadImage_3',
            query: {
              url,
              resourceType,
              publicId,
              //
              createdAt,
              //
              geohash,
              geoLocIsAvailable,
              //
              caption,
              emotionalAppeal: JSON.stringify(emotionalAppeal),
              spotType:  JSON.stringify(spotType),
              anyoneCanVisitThisSpot
            }
          })
          //
          console.log("[go to 3]")
          //
        //}else{
          //gen.mutations.snackbar_alert(state, {
            //msg: 'Please select at least one tag in location visible related to the image'
          //})
        //}
      }
  })
  //
  }, */
  //
  getTags_setDropdownOptions_uploadImage: function getTags_setDropdownOptions_uploadImage(state2, payload) {
    //
    var qTag = payload.qTag;
    var qStr = payload.qStr;
    //
    if (qTag.length != 0 && qTag != undefined && qTag != null) {
      //
      __WEBPACK_IMPORTED_MODULE_3__gen__["a" /* default */].actions.getTags_uploadImage(state, {
        qTag: qTag,
        qStr: qStr
      }).then(function (response) {
        //
        var result = response.data;
        //
        if (qTag == 'locationVisible') {
          state.locationVisible_uploadImage = state.locationVisible_uploadImage.concat(result); //vuetify component helping here, check duplicate
        } else if (qTag == 'emotionalAppeal') {
          state.emotionalAppeal_uploadImage = state.emotionalAppeal_uploadImage.concat(result);
        } else if (qTag == 'spotType') {
          __WEBPACK_IMPORTED_MODULE_5__uploadImage_4__["a" /* default */].state.spotType_uploadImage = __WEBPACK_IMPORTED_MODULE_5__uploadImage_4__["a" /* default */].state.spotType_uploadImage.concat(result);
        } else if (qTag == 'keywords') {
          __WEBPACK_IMPORTED_MODULE_6__uploadImage_5__["a" /* default */].state.keywords_uploadImage = __WEBPACK_IMPORTED_MODULE_6__uploadImage_5__["a" /* default */].state.keywords_uploadImage.concat(result);
        }
        //
      });
      //
    }
  }
};

var actions = {
  GET_SUGGESTIONS: function GET_SUGGESTIONS(_ref, payload) {
    var _this = this;

    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
        var tagCatType, _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tagCatType = payload.tagCatType;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api__["p" /* getSuggestions */])({ tagCat: tagCatType }));

              case 3:
                _ref3 = _context.sent;
                data = _ref3.data;

                resolve(data);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gen__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_auth__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__googleCloudVisionAPI__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imaggaAPI__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__uploadImage_4__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uploadImage_3__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);







var ls = __webpack_require__(27);







var state = {
  keywords_uploadImage: [],
  selectedKeywords_uploadImage: [],
  showShareButton: false
};

var getters = {
  selectedKeywords_uploadImage: function selectedKeywords_uploadImage(state) {
    return state.selectedKeywords_uploadImage;
  }
};

var mutations = {
  //SHARE PHOTO
  sharePhoto_uploadImage_5: function sharePhoto_uploadImage_5(state2, payload) {
    state.showShareButton = true;
    //
    //if(payload.keywords.length != 0){ //not empty
    //if(payload.locationVisible.length != 0) {
    //proceed
    //
    //axios
    __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__api__["n" /* uploadImage */], {
      params: {
        isCron: false,
        anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot,
        caption: payload.caption, //
        publicId: payload.publicId,
        //
        createdAt: payload.createdAt, //
        //
        emotionalAppeal: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload.emotionalAppeal),
        hasGeohash: payload.hasGeohash, //
        keywords: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload.keywords),
        locationVisible: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload.locationVisible), //
        resourceType: payload.resourceType, //
        //
        shareSpotLocation: payload.shareSpotLocation, //
        //
        spotType: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload.spotType),
        url: payload.url, //
        //
        //user depended //added later, not coming from dom/link
        uid: __WEBPACK_IMPORTED_MODULE_4__auth_auth__["a" /* default */].state.user.uid,
        uploader: 'user',
        email: __WEBPACK_IMPORTED_MODULE_4__auth_auth__["a" /* default */].state.user.email,
        displayName: __WEBPACK_IMPORTED_MODULE_4__auth_auth__["a" /* default */].state.user.displayName,
        displayPic: __WEBPACK_IMPORTED_MODULE_4__auth_auth__["a" /* default */].state.user.photoURL,
        myPhoto: true,
        photoSourceLink: '',
        licenseType: '',
        pic_desc: payload.travelInfo,
        mon: payload._mon2,
        dur: payload._dur2
      }
    }).then(function (response) {
      state.showShareButton = false;
      __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push('/?loc=Worldwide');
      // router.push(`/profile?selected_tab=shared&profile_id=${auth.state.user.uid}&uploader=user`)
      if (payload.resourceType === 'video') {
        __WEBPACK_IMPORTED_MODULE_3__gen__["a" /* default */].mutations.snackbar_alert(state, {
          msg: 'Video uploaded !'
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__gen__["a" /* default */].mutations.snackbar_alert(state, {
          msg: 'Image uploaded !'
        });
      }
      // empty variables
      __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__["a" /* default */].state.caption_uploadImage = ' ';
      state.selectedKeywords_uploadImage = [];
      __WEBPACK_IMPORTED_MODULE_9__uploadImage_4__["a" /* default */].state.selectedSpotType_uploadImage = [];
      __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__["a" /* default */].state.selectedemotionalAppeal_uploadImage = [];
    }).catch(function (e) {
      state.showShareButton = false;
      // console.log("[exception][uploadImage_5]", e)
    });
    /* gen
       .actions
       .axiosGetReq(state, {
         url: 'https://us-central1-travel-app-admin.cloudfunctions.net/uploadImage',
         obj: {
           anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot,
           caption: payload.caption, //
           publicId: payload.publicId,
           //
           createdAt: payload.createdAt, //
           //
           emotionalAppeal: JSON.stringify(payload.emotionalAppeal),
           hasGeohash: payload.hasGeohash, //
           keywords: JSON.stringify(payload.keywords),
           locationVisible: JSON.stringify(payload.locationVisible), //
           resourceType: payload.resourceType, //
           //
           shareSpotLocation: payload.shareSpotLocation, //
           //
           spotType: JSON.stringify(payload.spotType),
           url: payload.url, //
           //
           //user depended //added later, not coming from dom/link
           uid: auth.state.user.uid,
           uploader: 'user',
           email: auth.state.user.email,
           displayName: auth.state.user.displayName,
           displayPic: auth.state.user.photoURL
         }
       }).then((response) => {
         console.log(response.data)
         state.showShareButton = false
         router.push('/')
         gen.mutations.snackbar_alert(state, {
           msg: 'Image uploaded !'
         })
         // empty variables
         uploadImage_2.state.caption_uploadImage = ''
         state.selectedKeywords_uploadImage = []
         uploadImage_4.state.selectedSpotType_uploadImage = []
         uploadImage_2.state.selectedemotionalAppeal_uploadImage = []
       }).catch((e) => {
         state.showShareButton = false
         console.log("[exception][uploadImage_5]", e)
       })
     //
    //}else{
     //gen.mutations.snackbar_alert(state, {
       //msg: 'Please select at least one tag of location visible related to the image'
     //})
    //}
    //}else{ //error
    //gen.mutations.snackbar_alert(state, {
     //msg: 'Please select at least one keyword related to the image'
    //}) */
    //}
    //
  },

  //****** GET SUGGESTIONS FROM LOCAL STORAGE ******/
  getGoogleVisionAPISuggestionFromLocalStorage: function getGoogleVisionAPISuggestionFromLocalStorage(state2) {
    // landmark & keywords // google vision api + imagga
    //
    __WEBPACK_IMPORTED_MODULE_5__googleCloudVisionAPI__["a" /* default */].state.googleCloudVisionAPI_landmarkSuggestion = JSON.parse(ls.get('googleVisionAPI_landmarkSuggestion'));
    //
    __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__["a" /* default */].state.locationVisible_uploadImage = __WEBPACK_IMPORTED_MODULE_5__googleCloudVisionAPI__["a" /* default */].state.googleCloudVisionAPI_landmarkSuggestion;
    //
    __WEBPACK_IMPORTED_MODULE_5__googleCloudVisionAPI__["a" /* default */].state.googleCloudVisionAPI_labelSuggestion = JSON.parse(ls.get('googleVisionAPI_labelSuggestion'));
    //
    state.keywords_uploadImage = state.keywords_uploadImage.concat(__WEBPACK_IMPORTED_MODULE_5__googleCloudVisionAPI__["a" /* default */].state.googleCloudVisionAPI_labelSuggestion); //dropdown
    //
    __WEBPACK_IMPORTED_MODULE_6__imaggaAPI__["a" /* default */].state.imaggaSuggestion = __WEBPACK_IMPORTED_MODULE_3__gen__["a" /* default */].actions.arrayUnique(__WEBPACK_IMPORTED_MODULE_6__imaggaAPI__["a" /* default */].state.imaggaSuggestion.concat(__WEBPACK_IMPORTED_MODULE_5__googleCloudVisionAPI__["a" /* default */].state.googleCloudVisionAPI_labelSuggestion)); //chips

    //imagga
    state.keywords_uploadImage = JSON.parse(ls.get('imaggaSuggestions'));
    //
    __WEBPACK_IMPORTED_MODULE_6__imaggaAPI__["a" /* default */].state.imaggaSuggestion = __WEBPACK_IMPORTED_MODULE_3__gen__["a" /* default */].actions.arrayUnique(JSON.parse(ls.get('imaggaSuggestions')));
  },

  //****** GET SUGGESTIONS FROM LOCAL STORAGE ENDS ******/
  //
  //****** UI LOGICS - SELECT/DESELECT ******/
  selectThisImaggaSuggestion: function selectThisImaggaSuggestion(state2, payload) {
    //ui logic //select deselect
    //
    var tag = payload.tag;
    //
    state.selectedKeywords_uploadImage.push(tag);
  },

  //
  deselectThisImaggaSuggestion: function deselectThisImaggaSuggestion(state, payload) {
    //ui logic //select deselect
    //
    var tag = payload.tag;
    //
    var keyOfSelectedArr = state.selectedKeywords_uploadImage.indexOf(tag); //key of selected array
    state.selectedKeywords_uploadImage.splice(keyOfSelectedArr, 1);
    //
  },

  //
  selectThisGoogleVisionAPI_landmark: function selectThisGoogleVisionAPI_landmark(state2, payload) {
    //ui logic //select deselect
    //
    var tag = payload.tag;
    //
    __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__["a" /* default */].state.selectedLocationVisible_uploadImage.push(tag);
  },

  //
  deselectThisGoogleVisionAPI_landmark: function deselectThisGoogleVisionAPI_landmark(state, payload) {
    //ui logic //select deselect
    //
    var tag = payload.tag;
    //
    var keyOfSelectedArr = __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__["a" /* default */].state.selectedLocationVisible_uploadImage.indexOf(tag); //key of selected array
    __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__["a" /* default */].state.selectedLocationVisible_uploadImage.splice(keyOfSelectedArr, 1);
    //
  }
  /**** UI LOGICS - SELECT/DESELECT ENDS ****/

};

var actions = {
  //
  // new share image
  SHARE_UPLOAD_IMAGE: function SHARE_UPLOAD_IMAGE(_ref, payload) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__api__["o" /* upload_2 */], {
                params: payload
              });

            case 3:
              _ref2 = _context.sent;
              data = _ref2.data;

              __WEBPACK_IMPORTED_MODULE_9__uploadImage_4__["a" /* default */].state.anyoneCanVisitThisSpot_uploadImage = [];
              __WEBPACK_IMPORTED_MODULE_10__uploadImage_3__["a" /* default */].state.geoLocIsAvailable_uploadImage_3 = false;
              __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__["a" /* default */].state.caption_uploadImage = ' ';
              __WEBPACK_IMPORTED_MODULE_10__uploadImage_3__["a" /* default */].state.travelInfo = '';
              __WEBPACK_IMPORTED_MODULE_7__uploadImage_2__["a" /* default */].state.selectedemotionalAppeal_uploadImage = [];
              state.selectedKeywords_uploadImage = [];
              __WEBPACK_IMPORTED_MODULE_9__uploadImage_4__["a" /* default */].state.selectedSpotType_uploadImage = [];
              __WEBPACK_IMPORTED_MODULE_10__uploadImage_3__["a" /* default */].state.geohashVal = '';
              // router.push('/')
              setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push({
                  path: '/id/' + payload.photoId + '?inapp=true'
                });
              }, 1000);

              if (payload.resourceType == 'video') {
                __WEBPACK_IMPORTED_MODULE_3__gen__["a" /* default */].mutations.snackbar_alert(state, {
                  msg: 'Video uploaded !'
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_3__gen__["a" /* default */].mutations.snackbar_alert(state, {
                  msg: 'Image uploaded !'
                });
              }
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](0);

              console.log(_context.t0);

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 17]]);
    }))();
  }
  //

};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ })

},[265]);


// WEBPACK FOOTER //
// static/js/app.d656c15cc20535141587.js